/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function nt(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const o of e.split(",")) t[o] = 1;
  return (o) => o in t;
}
const q = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Pt = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ae = () => {
}, Xs = () => !1, ro = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Do = (e) => e.startsWith("onUpdate:"), ee = Object.assign, Nn = (e, t) => {
  const o = e.indexOf(t);
  o > -1 && e.splice(o, 1);
}, Zs = Object.prototype.hasOwnProperty, H = (e, t) => Zs.call(e, t), T = Array.isArray, Et = (e) => jo(e) === "[object Map]", Ar = (e) => jo(e) === "[object Set]", k = (e) => typeof e == "function", Z = (e) => typeof e == "string", rt = (e) => typeof e == "symbol", J = (e) => e !== null && typeof e == "object", On = (e) => (J(e) || k(e)) && k(e.then) && k(e.catch), Ir = Object.prototype.toString, jo = (e) => Ir.call(e), Dn = (e) => jo(e).slice(8, -1), Fo = (e) => jo(e) === "[object Object]", Vn = (e) => Z(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Jt = /* @__PURE__ */ nt(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ei = /* @__PURE__ */ nt(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), zo = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (o) => t[o] || (t[o] = e(o));
}, ti = /-(\w)/g, Oe = zo(
  (e) => e.replace(ti, (t, o) => o ? o.toUpperCase() : "")
), oi = /\B([A-Z])/g, Ie = zo(
  (e) => e.replace(oi, "-$1").toLowerCase()
), Ho = zo((e) => e.charAt(0).toUpperCase() + e.slice(1)), yt = zo(
  (e) => e ? `on${Ho(e)}` : ""
), ht = (e, t) => !Object.is(e, t), Bt = (e, ...t) => {
  for (let o = 0; o < e.length; o++)
    e[o](...t);
}, Vo = (e, t, o, n = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: o
  });
}, ni = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, qn = (e) => {
  const t = Z(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Gn;
const so = () => Gn || (Gn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function se(e) {
  if (T(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = Z(n) ? li(n) : se(n);
      if (r)
        for (const s in r)
          t[s] = r[s];
    }
    return t;
  } else if (Z(e) || J(e))
    return e;
}
const ri = /;(?![^(]*\))/g, si = /:([^]+)/, ii = /\/\*[^]*?\*\//g;
function li(e) {
  const t = {};
  return e.replace(ii, "").split(ri).forEach((o) => {
    if (o) {
      const n = o.split(si);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function $t(e) {
  let t = "";
  if (Z(e))
    t = e;
  else if (T(e))
    for (let o = 0; o < e.length; o++) {
      const n = $t(e[o]);
      n && (t += n + " ");
    }
  else if (J(e))
    for (const o in e)
      e[o] && (t += o + " ");
  return t.trim();
}
const ci = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", ai = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", ui = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", fi = /* @__PURE__ */ nt(ci), di = /* @__PURE__ */ nt(ai), pi = /* @__PURE__ */ nt(ui), hi = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", gi = /* @__PURE__ */ nt(hi);
function kr(e) {
  return !!e || e === "";
}
const Pr = (e) => !!(e && e.__v_isRef === !0), oe = (e) => Z(e) ? e : e == null ? "" : T(e) || J(e) && (e.toString === Ir || !k(e.toString)) ? Pr(e) ? oe(e.value) : JSON.stringify(e, $r, 2) : String(e), $r = (e, t) => Pr(t) ? $r(e, t.value) : Et(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (o, [n, r], s) => (o[Yo(n, s) + " =>"] = r, o),
    {}
  )
} : Ar(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((o) => Yo(o))
} : rt(t) ? Yo(t) : J(t) && !T(t) && !Fo(t) ? String(t) : t, Yo = (e, t = "") => {
  var o;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    rt(e) ? `Symbol(${(o = e.description) != null ? o : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Qe(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Ae;
class mi {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Ae, !t && Ae && (this.index = (Ae.scopes || (Ae.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].pause();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].resume();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const o = Ae;
      try {
        return Ae = this, t();
      } finally {
        Ae = o;
      }
    } else process.env.NODE_ENV !== "production" && Qe("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Ae = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Ae = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let o, n;
      for (o = 0, n = this.effects.length; o < n; o++)
        this.effects[o].stop();
      for (this.effects.length = 0, o = 0, n = this.cleanups.length; o < n; o++)
        this.cleanups[o]();
      if (this.cleanups.length = 0, this.scopes) {
        for (o = 0, n = this.scopes.length; o < n; o++)
          this.scopes[o].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function bi() {
  return Ae;
}
let B;
const Qo = /* @__PURE__ */ new WeakSet();
class Mr {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Ae && Ae.active && Ae.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Qo.has(this) && (Qo.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || jr(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Jn(this), Fr(this);
    const t = B, o = Fe;
    B = this, Fe = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && B !== this && Qe(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), zr(this), B = t, Fe = o, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Tn(t);
      this.deps = this.depsTail = void 0, Jn(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Qo.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    cn(this) && this.run();
  }
  get dirty() {
    return cn(this);
  }
}
let Rr = 0, Yt, Qt;
function jr(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Qt, Qt = e;
    return;
  }
  e.next = Yt, Yt = e;
}
function Sn() {
  Rr++;
}
function Cn() {
  if (--Rr > 0)
    return;
  if (Qt) {
    let t = Qt;
    for (Qt = void 0; t; ) {
      const o = t.next;
      t.next = void 0, t.flags &= -9, t = o;
    }
  }
  let e;
  for (; Yt; ) {
    let t = Yt;
    for (Yt = void 0; t; ) {
      const o = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (n) {
          e || (e = n);
        }
      t = o;
    }
  }
  if (e) throw e;
}
function Fr(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function zr(e) {
  let t, o = e.depsTail, n = o;
  for (; n; ) {
    const r = n.prevDep;
    n.version === -1 ? (n === o && (o = r), Tn(n), vi(n)) : t = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = r;
  }
  e.deps = t, e.depsTail = o;
}
function cn(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Hr(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Hr(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Zt))
    return;
  e.globalVersion = Zt;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !cn(e)) {
    e.flags &= -3;
    return;
  }
  const o = B, n = Fe;
  B = e, Fe = !0;
  try {
    Fr(e);
    const r = e.fn(e._value);
    (t.version === 0 || ht(r, e._value)) && (e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    B = o, Fe = n, zr(e), e.flags &= -3;
  }
}
function Tn(e, t = !1) {
  const { dep: o, prevSub: n, nextSub: r } = e;
  if (n && (n.nextSub = r, e.prevSub = void 0), r && (r.prevSub = n, e.nextSub = void 0), process.env.NODE_ENV !== "production" && o.subsHead === e && (o.subsHead = r), o.subs === e && (o.subs = n, !n && o.computed)) {
    o.computed.flags &= -5;
    for (let s = o.computed.deps; s; s = s.nextDep)
      Tn(s, !0);
  }
  !t && !--o.sc && o.map && o.map.delete(o.key);
}
function vi(e) {
  const { prevDep: t, nextDep: o } = e;
  t && (t.nextDep = o, e.prevDep = void 0), o && (o.prevDep = t, e.nextDep = void 0);
}
let Fe = !0;
const Lr = [];
function st() {
  Lr.push(Fe), Fe = !1;
}
function it() {
  const e = Lr.pop();
  Fe = e === void 0 ? !0 : e;
}
function Jn(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const o = B;
    B = void 0;
    try {
      t();
    } finally {
      B = o;
    }
  }
}
let Zt = 0;
class _i {
  constructor(t, o) {
    this.sub = t, this.dep = o, this.version = o.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class An {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!B || !Fe || B === this.computed)
      return;
    let o = this.activeLink;
    if (o === void 0 || o.sub !== B)
      o = this.activeLink = new _i(B, this), B.deps ? (o.prevDep = B.depsTail, B.depsTail.nextDep = o, B.depsTail = o) : B.deps = B.depsTail = o, Br(o);
    else if (o.version === -1 && (o.version = this.version, o.nextDep)) {
      const n = o.nextDep;
      n.prevDep = o.prevDep, o.prevDep && (o.prevDep.nextDep = n), o.prevDep = B.depsTail, o.nextDep = void 0, B.depsTail.nextDep = o, B.depsTail = o, B.deps === o && (B.deps = n);
    }
    return process.env.NODE_ENV !== "production" && B.onTrack && B.onTrack(
      ee(
        {
          effect: B
        },
        t
      )
    ), o;
  }
  trigger(t) {
    this.version++, Zt++, this.notify(t);
  }
  notify(t) {
    Sn();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let o = this.subsHead; o; o = o.nextSub)
          o.sub.onTrigger && !(o.sub.flags & 8) && o.sub.onTrigger(
            ee(
              {
                effect: o.sub
              },
              t
            )
          );
      for (let o = this.subs; o; o = o.prevSub)
        o.sub.notify() && o.sub.dep.notify();
    } finally {
      Cn();
    }
  }
}
function Br(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let n = t.deps; n; n = n.nextDep)
        Br(n);
    }
    const o = e.dep.subs;
    o !== e && (e.prevSub = o, o && (o.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const an = /* @__PURE__ */ new WeakMap(), xt = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), un = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), eo = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function le(e, t, o) {
  if (Fe && B) {
    let n = an.get(e);
    n || an.set(e, n = /* @__PURE__ */ new Map());
    let r = n.get(o);
    r || (n.set(o, r = new An()), r.map = n, r.key = o), process.env.NODE_ENV !== "production" ? r.track({
      target: e,
      type: t,
      key: o
    }) : r.track();
  }
}
function Ge(e, t, o, n, r, s) {
  const i = an.get(e);
  if (!i) {
    Zt++;
    return;
  }
  const c = (f) => {
    f && (process.env.NODE_ENV !== "production" ? f.trigger({
      target: e,
      type: t,
      key: o,
      newValue: n,
      oldValue: r,
      oldTarget: s
    }) : f.trigger());
  };
  if (Sn(), t === "clear")
    i.forEach(c);
  else {
    const f = T(e), g = f && Vn(o);
    if (f && o === "length") {
      const h = Number(n);
      i.forEach((d, v) => {
        (v === "length" || v === eo || !rt(v) && v >= h) && c(d);
      });
    } else
      switch ((o !== void 0 || i.has(void 0)) && c(i.get(o)), g && c(i.get(eo)), t) {
        case "add":
          f ? g && c(i.get("length")) : (c(i.get(xt)), Et(e) && c(i.get(un)));
          break;
        case "delete":
          f || (c(i.get(xt)), Et(e) && c(i.get(un)));
          break;
        case "set":
          Et(e) && c(i.get(xt));
          break;
      }
  }
  Cn();
}
function Tt(e) {
  const t = M(e);
  return t === e ? t : (le(t, "iterate", eo), we(e) ? t : t.map(be));
}
function Lo(e) {
  return le(e = M(e), "iterate", eo), e;
}
const yi = {
  __proto__: null,
  [Symbol.iterator]() {
    return Xo(this, Symbol.iterator, be);
  },
  concat(...e) {
    return Tt(this).concat(
      ...e.map((t) => T(t) ? Tt(t) : t)
    );
  },
  entries() {
    return Xo(this, "entries", (e) => (e[1] = be(e[1]), e));
  },
  every(e, t) {
    return et(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return et(this, "filter", e, t, (o) => o.map(be), arguments);
  },
  find(e, t) {
    return et(this, "find", e, t, be, arguments);
  },
  findIndex(e, t) {
    return et(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return et(this, "findLast", e, t, be, arguments);
  },
  findLastIndex(e, t) {
    return et(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return et(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return Zo(this, "includes", e);
  },
  indexOf(...e) {
    return Zo(this, "indexOf", e);
  },
  join(e) {
    return Tt(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return Zo(this, "lastIndexOf", e);
  },
  map(e, t) {
    return et(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Ut(this, "pop");
  },
  push(...e) {
    return Ut(this, "push", e);
  },
  reduce(e, ...t) {
    return Yn(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Yn(this, "reduceRight", e, t);
  },
  shift() {
    return Ut(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return et(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Ut(this, "splice", e);
  },
  toReversed() {
    return Tt(this).toReversed();
  },
  toSorted(e) {
    return Tt(this).toSorted(e);
  },
  toSpliced(...e) {
    return Tt(this).toSpliced(...e);
  },
  unshift(...e) {
    return Ut(this, "unshift", e);
  },
  values() {
    return Xo(this, "values", be);
  }
};
function Xo(e, t, o) {
  const n = Lo(e), r = n[t]();
  return n !== e && !we(e) && (r._next = r.next, r.next = () => {
    const s = r._next();
    return s.value && (s.value = o(s.value)), s;
  }), r;
}
const wi = Array.prototype;
function et(e, t, o, n, r, s) {
  const i = Lo(e), c = i !== e && !we(e), f = i[t];
  if (f !== wi[t]) {
    const d = f.apply(e, s);
    return c ? be(d) : d;
  }
  let g = o;
  i !== e && (c ? g = function(d, v) {
    return o.call(this, be(d), v, e);
  } : o.length > 2 && (g = function(d, v) {
    return o.call(this, d, v, e);
  }));
  const h = f.call(i, g, n);
  return c && r ? r(h) : h;
}
function Yn(e, t, o, n) {
  const r = Lo(e);
  let s = o;
  return r !== e && (we(e) ? o.length > 3 && (s = function(i, c, f) {
    return o.call(this, i, c, f, e);
  }) : s = function(i, c, f) {
    return o.call(this, i, be(c), f, e);
  }), r[t](s, ...n);
}
function Zo(e, t, o) {
  const n = M(e);
  le(n, "iterate", eo);
  const r = n[t](...o);
  return (r === -1 || r === !1) && So(o[0]) ? (o[0] = M(o[0]), n[t](...o)) : r;
}
function Ut(e, t, o = []) {
  st(), Sn();
  const n = M(e)[t].apply(e, o);
  return Cn(), it(), n;
}
const Ei = /* @__PURE__ */ nt("__proto__,__v_isRef,__isVue"), Ur = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(rt)
);
function xi(e) {
  rt(e) || (e = String(e));
  const t = M(this);
  return le(t, "has", e), t.hasOwnProperty(e);
}
class Wr {
  constructor(t = !1, o = !1) {
    this._isReadonly = t, this._isShallow = o;
  }
  get(t, o, n) {
    if (o === "__v_skip") return t.__v_skip;
    const r = this._isReadonly, s = this._isShallow;
    if (o === "__v_isReactive")
      return !r;
    if (o === "__v_isReadonly")
      return r;
    if (o === "__v_isShallow")
      return s;
    if (o === "__v_raw")
      return n === (r ? s ? Qr : Yr : s ? Jr : Gr).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(n) ? t : void 0;
    const i = T(t);
    if (!r) {
      let f;
      if (i && (f = yi[o]))
        return f;
      if (o === "hasOwnProperty")
        return xi;
    }
    const c = Reflect.get(
      t,
      o,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      ie(t) ? t : n
    );
    return (rt(o) ? Ur.has(o) : Ei(o)) || (r || le(t, "get", o), s) ? c : ie(c) ? i && Vn(o) ? c : c.value : J(c) ? r ? Xr(c) : Uo(c) : c;
  }
}
class Kr extends Wr {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, o, n, r) {
    let s = t[o];
    if (!this._isShallow) {
      const f = ot(s);
      if (!we(n) && !ot(n) && (s = M(s), n = M(n)), !T(t) && ie(s) && !ie(n))
        return f ? !1 : (s.value = n, !0);
    }
    const i = T(t) && Vn(o) ? Number(o) < t.length : H(t, o), c = Reflect.set(
      t,
      o,
      n,
      ie(t) ? t : r
    );
    return t === M(r) && (i ? ht(n, s) && Ge(t, "set", o, n, s) : Ge(t, "add", o, n)), c;
  }
  deleteProperty(t, o) {
    const n = H(t, o), r = t[o], s = Reflect.deleteProperty(t, o);
    return s && n && Ge(t, "delete", o, void 0, r), s;
  }
  has(t, o) {
    const n = Reflect.has(t, o);
    return (!rt(o) || !Ur.has(o)) && le(t, "has", o), n;
  }
  ownKeys(t) {
    return le(
      t,
      "iterate",
      T(t) ? "length" : xt
    ), Reflect.ownKeys(t);
  }
}
class qr extends Wr {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, o) {
    return process.env.NODE_ENV !== "production" && Qe(
      `Set operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, o) {
    return process.env.NODE_ENV !== "production" && Qe(
      `Delete operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const Ni = /* @__PURE__ */ new Kr(), Oi = /* @__PURE__ */ new qr(), Di = /* @__PURE__ */ new Kr(!0), Vi = /* @__PURE__ */ new qr(!0), fn = (e) => e, go = (e) => Reflect.getPrototypeOf(e);
function Si(e, t, o) {
  return function(...n) {
    const r = this.__v_raw, s = M(r), i = Et(s), c = e === "entries" || e === Symbol.iterator && i, f = e === "keys" && i, g = r[e](...n), h = o ? fn : t ? dn : be;
    return !t && le(
      s,
      "iterate",
      f ? un : xt
    ), {
      // iterator protocol
      next() {
        const { value: d, done: v } = g.next();
        return v ? { value: d, done: v } : {
          value: c ? [h(d[0]), h(d[1])] : h(d),
          done: v
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function mo(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const o = t[0] ? `on key "${t[0]}" ` : "";
      Qe(
        `${Ho(e)} operation ${o}failed: target is readonly.`,
        M(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ci(e, t) {
  const o = {
    get(r) {
      const s = this.__v_raw, i = M(s), c = M(r);
      e || (ht(r, c) && le(i, "get", r), le(i, "get", c));
      const { has: f } = go(i), g = t ? fn : e ? dn : be;
      if (f.call(i, r))
        return g(s.get(r));
      if (f.call(i, c))
        return g(s.get(c));
      s !== i && s.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && le(M(r), "iterate", xt), Reflect.get(r, "size", r);
    },
    has(r) {
      const s = this.__v_raw, i = M(s), c = M(r);
      return e || (ht(r, c) && le(i, "has", r), le(i, "has", c)), r === c ? s.has(r) : s.has(r) || s.has(c);
    },
    forEach(r, s) {
      const i = this, c = i.__v_raw, f = M(c), g = t ? fn : e ? dn : be;
      return !e && le(f, "iterate", xt), c.forEach((h, d) => r.call(s, g(h), g(d), i));
    }
  };
  return ee(
    o,
    e ? {
      add: mo("add"),
      set: mo("set"),
      delete: mo("delete"),
      clear: mo("clear")
    } : {
      add(r) {
        !t && !we(r) && !ot(r) && (r = M(r));
        const s = M(this);
        return go(s).has.call(s, r) || (s.add(r), Ge(s, "add", r, r)), this;
      },
      set(r, s) {
        !t && !we(s) && !ot(s) && (s = M(s));
        const i = M(this), { has: c, get: f } = go(i);
        let g = c.call(i, r);
        g ? process.env.NODE_ENV !== "production" && Qn(i, c, r) : (r = M(r), g = c.call(i, r));
        const h = f.call(i, r);
        return i.set(r, s), g ? ht(s, h) && Ge(i, "set", r, s, h) : Ge(i, "add", r, s), this;
      },
      delete(r) {
        const s = M(this), { has: i, get: c } = go(s);
        let f = i.call(s, r);
        f ? process.env.NODE_ENV !== "production" && Qn(s, i, r) : (r = M(r), f = i.call(s, r));
        const g = c ? c.call(s, r) : void 0, h = s.delete(r);
        return f && Ge(s, "delete", r, void 0, g), h;
      },
      clear() {
        const r = M(this), s = r.size !== 0, i = process.env.NODE_ENV !== "production" ? Et(r) ? new Map(r) : new Set(r) : void 0, c = r.clear();
        return s && Ge(
          r,
          "clear",
          void 0,
          void 0,
          i
        ), c;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    o[r] = Si(r, e, t);
  }), o;
}
function Bo(e, t) {
  const o = Ci(e, t);
  return (n, r, s) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? n : Reflect.get(
    H(o, r) && r in n ? o : n,
    r,
    s
  );
}
const Ti = {
  get: /* @__PURE__ */ Bo(!1, !1)
}, Ai = {
  get: /* @__PURE__ */ Bo(!1, !0)
}, Ii = {
  get: /* @__PURE__ */ Bo(!0, !1)
}, ki = {
  get: /* @__PURE__ */ Bo(!0, !0)
};
function Qn(e, t, o) {
  const n = M(o);
  if (n !== o && t.call(e, n)) {
    const r = Dn(e);
    Qe(
      `Reactive ${r} contains both the raw and reactive versions of the same object${r === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Gr = /* @__PURE__ */ new WeakMap(), Jr = /* @__PURE__ */ new WeakMap(), Yr = /* @__PURE__ */ new WeakMap(), Qr = /* @__PURE__ */ new WeakMap();
function Pi(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function $i(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Pi(Dn(e));
}
function Uo(e) {
  return ot(e) ? e : Wo(
    e,
    !1,
    Ni,
    Ti,
    Gr
  );
}
function Mi(e) {
  return Wo(
    e,
    !1,
    Di,
    Ai,
    Jr
  );
}
function Xr(e) {
  return Wo(
    e,
    !0,
    Oi,
    Ii,
    Yr
  );
}
function Je(e) {
  return Wo(
    e,
    !0,
    Vi,
    ki,
    Qr
  );
}
function Wo(e, t, o, n, r) {
  if (!J(e))
    return process.env.NODE_ENV !== "production" && Qe(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const s = r.get(e);
  if (s)
    return s;
  const i = $i(e);
  if (i === 0)
    return e;
  const c = new Proxy(
    e,
    i === 2 ? n : o
  );
  return r.set(e, c), c;
}
function Nt(e) {
  return ot(e) ? Nt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function ot(e) {
  return !!(e && e.__v_isReadonly);
}
function we(e) {
  return !!(e && e.__v_isShallow);
}
function So(e) {
  return e ? !!e.__v_raw : !1;
}
function M(e) {
  const t = e && e.__v_raw;
  return t ? M(t) : e;
}
function Ri(e) {
  return !H(e, "__v_skip") && Object.isExtensible(e) && Vo(e, "__v_skip", !0), e;
}
const be = (e) => J(e) ? Uo(e) : e, dn = (e) => J(e) ? Xr(e) : e;
function ie(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function at(e) {
  return ji(e, !1);
}
function ji(e, t) {
  return ie(e) ? e : new Fi(e, t);
}
class Fi {
  constructor(t, o) {
    this.dep = new An(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = o ? t : M(t), this._value = o ? t : be(t), this.__v_isShallow = o;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const o = this._rawValue, n = this.__v_isShallow || we(t) || ot(t);
    t = n ? t : M(t), ht(t, o) && (this._rawValue = t, this._value = n ? t : be(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: o
    }) : this.dep.trigger());
  }
}
function Zr(e) {
  return ie(e) ? e.value : e;
}
const zi = {
  get: (e, t, o) => t === "__v_raw" ? e : Zr(Reflect.get(e, t, o)),
  set: (e, t, o, n) => {
    const r = e[t];
    return ie(r) && !ie(o) ? (r.value = o, !0) : Reflect.set(e, t, o, n);
  }
};
function es(e) {
  return Nt(e) ? e : new Proxy(e, zi);
}
class Hi {
  constructor(t, o, n) {
    this.fn = t, this.setter = o, this._value = void 0, this.dep = new An(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Zt - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !o, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    B !== this)
      return jr(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Hr(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && Qe("Write operation failed: computed value is readonly");
  }
}
function Li(e, t, o = !1) {
  let n, r;
  k(e) ? n = e : (n = e.get, r = e.set);
  const s = new Hi(n, r, o);
  return process.env.NODE_ENV, s;
}
const bo = {}, Co = /* @__PURE__ */ new WeakMap();
let wt;
function Bi(e, t = !1, o = wt) {
  if (o) {
    let n = Co.get(o);
    n || Co.set(o, n = []), n.push(e);
  } else process.env.NODE_ENV !== "production" && !t && Qe(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function Ui(e, t, o = q) {
  const { immediate: n, deep: r, once: s, scheduler: i, augmentJob: c, call: f } = o, g = (V) => {
    (o.onWarn || Qe)(
      "Invalid watch source: ",
      V,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, h = (V) => r ? V : we(V) || r === !1 || r === 0 ? dt(V, 1) : dt(V);
  let d, v, x, C, $ = !1, ne = !1;
  if (ie(e) ? (v = () => e.value, $ = we(e)) : Nt(e) ? (v = () => h(e), $ = !0) : T(e) ? (ne = !0, $ = e.some((V) => Nt(V) || we(V)), v = () => e.map((V) => {
    if (ie(V))
      return V.value;
    if (Nt(V))
      return h(V);
    if (k(V))
      return f ? f(V, 2) : V();
    process.env.NODE_ENV !== "production" && g(V);
  })) : k(e) ? t ? v = f ? () => f(e, 2) : e : v = () => {
    if (x) {
      st();
      try {
        x();
      } finally {
        it();
      }
    }
    const V = wt;
    wt = d;
    try {
      return f ? f(e, 3, [C]) : e(C);
    } finally {
      wt = V;
    }
  } : (v = ae, process.env.NODE_ENV !== "production" && g(e)), t && r) {
    const V = v, re = r === !0 ? 1 / 0 : r;
    v = () => dt(V(), re);
  }
  const U = bi(), X = () => {
    d.stop(), U && U.active && Nn(U.effects, d);
  };
  if (s && t) {
    const V = t;
    t = (...re) => {
      V(...re), X();
    };
  }
  let D = ne ? new Array(e.length).fill(bo) : bo;
  const he = (V) => {
    if (!(!(d.flags & 1) || !d.dirty && !V))
      if (t) {
        const re = d.run();
        if (r || $ || (ne ? re.some((fe, G) => ht(fe, D[G])) : ht(re, D))) {
          x && x();
          const fe = wt;
          wt = d;
          try {
            const G = [
              re,
              // pass undefined as the old value when it's changed for the first time
              D === bo ? void 0 : ne && D[0] === bo ? [] : D,
              C
            ];
            f ? f(t, 3, G) : (
              // @ts-expect-error
              t(...G)
            ), D = re;
          } finally {
            wt = fe;
          }
        }
      } else
        d.run();
  };
  return c && c(he), d = new Mr(v), d.scheduler = i ? () => i(he, !1) : he, C = (V) => Bi(V, !1, d), x = d.onStop = () => {
    const V = Co.get(d);
    if (V) {
      if (f)
        f(V, 4);
      else
        for (const re of V) re();
      Co.delete(d);
    }
  }, process.env.NODE_ENV !== "production" && (d.onTrack = o.onTrack, d.onTrigger = o.onTrigger), t ? n ? he(!0) : D = d.run() : i ? i(he.bind(null, !0), !0) : d.run(), X.pause = d.pause.bind(d), X.resume = d.resume.bind(d), X.stop = X, X;
}
function dt(e, t = 1 / 0, o) {
  if (t <= 0 || !J(e) || e.__v_skip || (o = o || /* @__PURE__ */ new Set(), o.has(e)))
    return e;
  if (o.add(e), t--, ie(e))
    dt(e.value, t, o);
  else if (T(e))
    for (let n = 0; n < e.length; n++)
      dt(e[n], t, o);
  else if (Ar(e) || Et(e))
    e.forEach((n) => {
      dt(n, t, o);
    });
  else if (Fo(e)) {
    for (const n in e)
      dt(e[n], t, o);
    for (const n of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, n) && dt(e[n], t, o);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Ot = [];
function vo(e) {
  Ot.push(e);
}
function _o() {
  Ot.pop();
}
let en = !1;
function N(e, ...t) {
  if (en) return;
  en = !0, st();
  const o = Ot.length ? Ot[Ot.length - 1].component : null, n = o && o.appContext.config.warnHandler, r = Wi();
  if (n)
    Ft(
      n,
      o,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((s) => {
          var i, c;
          return (c = (i = s.toString) == null ? void 0 : i.call(s)) != null ? c : JSON.stringify(s);
        }).join(""),
        o && o.proxy,
        r.map(
          ({ vnode: s }) => `at <${Jo(o, s.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const s = [`[Vue warn]: ${e}`, ...t];
    r.length && s.push(`
`, ...Ki(r)), console.warn(...s);
  }
  it(), en = !1;
}
function Wi() {
  let e = Ot[Ot.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const o = t[0];
    o && o.vnode === e ? o.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function Ki(e) {
  const t = [];
  return e.forEach((o, n) => {
    t.push(...n === 0 ? [] : [`
`], ...qi(o));
  }), t;
}
function qi({ vnode: e, recurseCount: t }) {
  const o = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, r = ` at <${Jo(
    e.component,
    e.type,
    n
  )}`, s = ">" + o;
  return e.props ? [r, ...Gi(e.props), s] : [r + s];
}
function Gi(e) {
  const t = [], o = Object.keys(e);
  return o.slice(0, 3).forEach((n) => {
    t.push(...ts(n, e[n]));
  }), o.length > 3 && t.push(" ..."), t;
}
function ts(e, t, o) {
  return Z(t) ? (t = JSON.stringify(t), o ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? o ? t : [`${e}=${t}`] : ie(t) ? (t = ts(e, M(t.value), !0), o ? t : [`${e}=Ref<`, t, ">"]) : k(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = M(t), o ? t : [`${e}=`, t]);
}
const In = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Ft(e, t, o, n) {
  try {
    return n ? e(...n) : e();
  } catch (r) {
    io(r, t, o);
  }
}
function Xe(e, t, o, n) {
  if (k(e)) {
    const r = Ft(e, t, o, n);
    return r && On(r) && r.catch((s) => {
      io(s, t, o);
    }), r;
  }
  if (T(e)) {
    const r = [];
    for (let s = 0; s < e.length; s++)
      r.push(Xe(e[s], t, o, n));
    return r;
  } else process.env.NODE_ENV !== "production" && N(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function io(e, t, o, n = !0) {
  const r = t ? t.vnode : null, { errorHandler: s, throwUnhandledErrorInProduction: i } = t && t.appContext.config || q;
  if (t) {
    let c = t.parent;
    const f = t.proxy, g = process.env.NODE_ENV !== "production" ? In[o] : `https://vuejs.org/error-reference/#runtime-${o}`;
    for (; c; ) {
      const h = c.ec;
      if (h) {
        for (let d = 0; d < h.length; d++)
          if (h[d](e, f, g) === !1)
            return;
      }
      c = c.parent;
    }
    if (s) {
      st(), Ft(s, null, 10, [
        e,
        f,
        g
      ]), it();
      return;
    }
  }
  Ji(e, o, r, n, i);
}
function Ji(e, t, o, n = !0, r = !1) {
  if (process.env.NODE_ENV !== "production") {
    const s = In[t];
    if (o && vo(o), N(`Unhandled error${s ? ` during execution of ${s}` : ""}`), o && _o(), n)
      throw e;
    console.error(e);
  } else {
    if (r)
      throw e;
    console.error(e);
  }
}
const ye = [];
let qe = -1;
const Mt = [];
let ut = null, kt = 0;
const os = /* @__PURE__ */ Promise.resolve();
let To = null;
const Yi = 100;
function ns(e) {
  const t = To || os;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Qi(e) {
  let t = qe + 1, o = ye.length;
  for (; t < o; ) {
    const n = t + o >>> 1, r = ye[n], s = to(r);
    s < e || s === e && r.flags & 2 ? t = n + 1 : o = n;
  }
  return t;
}
function Ko(e) {
  if (!(e.flags & 1)) {
    const t = to(e), o = ye[ye.length - 1];
    !o || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= to(o) ? ye.push(e) : ye.splice(Qi(t), 0, e), e.flags |= 1, rs();
  }
}
function rs() {
  To || (To = os.then(ls));
}
function ss(e) {
  T(e) ? Mt.push(...e) : ut && e.id === -1 ? ut.splice(kt + 1, 0, e) : e.flags & 1 || (Mt.push(e), e.flags |= 1), rs();
}
function Xn(e, t, o = qe + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); o < ye.length; o++) {
    const n = ye[o];
    if (n && n.flags & 2) {
      if (e && n.id !== e.uid || process.env.NODE_ENV !== "production" && kn(t, n))
        continue;
      ye.splice(o, 1), o--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function is(e) {
  if (Mt.length) {
    const t = [...new Set(Mt)].sort(
      (o, n) => to(o) - to(n)
    );
    if (Mt.length = 0, ut) {
      ut.push(...t);
      return;
    }
    for (ut = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), kt = 0; kt < ut.length; kt++) {
      const o = ut[kt];
      process.env.NODE_ENV !== "production" && kn(e, o) || (o.flags & 4 && (o.flags &= -2), o.flags & 8 || o(), o.flags &= -2);
    }
    ut = null, kt = 0;
  }
}
const to = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function ls(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (o) => kn(e, o) : ae;
  try {
    for (qe = 0; qe < ye.length; qe++) {
      const o = ye[qe];
      if (o && !(o.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(o))
          continue;
        o.flags & 4 && (o.flags &= -2), Ft(
          o,
          o.i,
          o.i ? 15 : 14
        ), o.flags & 4 || (o.flags &= -2);
      }
    }
  } finally {
    for (; qe < ye.length; qe++) {
      const o = ye[qe];
      o && (o.flags &= -2);
    }
    qe = -1, ye.length = 0, is(e), To = null, (ye.length || Mt.length) && ls(e);
  }
}
function kn(e, t) {
  const o = e.get(t) || 0;
  if (o > Yi) {
    const n = t.i, r = n && Ws(n.type);
    return io(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, o + 1), !1;
}
let Ye = !1;
const yo = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (so().__VUE_HMR_RUNTIME__ = {
  createRecord: tn(cs),
  rerender: tn(el),
  reload: tn(tl)
});
const St = /* @__PURE__ */ new Map();
function Xi(e) {
  const t = e.type.__hmrId;
  let o = St.get(t);
  o || (cs(t, e.type), o = St.get(t)), o.instances.add(e);
}
function Zi(e) {
  St.get(e.type.__hmrId).instances.delete(e);
}
function cs(e, t) {
  return St.has(e) ? !1 : (St.set(e, {
    initialDef: Ao(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Ao(e) {
  return Ks(e) ? e.__vccOpts : e;
}
function el(e, t) {
  const o = St.get(e);
  o && (o.initialDef.render = t, [...o.instances].forEach((n) => {
    t && (n.render = t, Ao(n.type).render = t), n.renderCache = [], Ye = !0, n.update(), Ye = !1;
  }));
}
function tl(e, t) {
  const o = St.get(e);
  if (!o) return;
  t = Ao(t), Zn(o.initialDef, t);
  const n = [...o.instances];
  for (let r = 0; r < n.length; r++) {
    const s = n[r], i = Ao(s.type);
    let c = yo.get(i);
    c || (i !== o.initialDef && Zn(i, t), yo.set(i, c = /* @__PURE__ */ new Set())), c.add(s), s.appContext.propsCache.delete(s.type), s.appContext.emitsCache.delete(s.type), s.appContext.optionsCache.delete(s.type), s.ceReload ? (c.add(s), s.ceReload(t.styles), c.delete(s)) : s.parent ? Ko(() => {
      Ye = !0, s.parent.update(), Ye = !1, c.delete(s);
    }) : s.appContext.reload ? s.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), s.root.ce && s !== s.root && s.root.ce._removeChildStyle(i);
  }
  ss(() => {
    yo.clear();
  });
}
function Zn(e, t) {
  ee(e, t);
  for (const o in e)
    o !== "__file" && !(o in t) && delete e[o];
}
function tn(e) {
  return (t, o) => {
    try {
      return e(t, o);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let je, qt = [], pn = !1;
function lo(e, ...t) {
  je ? je.emit(e, ...t) : pn || qt.push({ event: e, args: t });
}
function Pn(e, t) {
  var o, n;
  je = e, je ? (je.enabled = !0, qt.forEach(({ event: r, args: s }) => je.emit(r, ...s)), qt = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((n = (o = window.navigator) == null ? void 0 : o.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((s) => {
    Pn(s, t);
  }), setTimeout(() => {
    je || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, pn = !0, qt = []);
  }, 3e3)) : (pn = !0, qt = []);
}
function ol(e, t) {
  lo("app:init", e, t, {
    Fragment: ce,
    Text: co,
    Comment: De,
    Static: xo
  });
}
function nl(e) {
  lo("app:unmount", e);
}
const rl = /* @__PURE__ */ $n(
  "component:added"
  /* COMPONENT_ADDED */
), as = /* @__PURE__ */ $n(
  "component:updated"
  /* COMPONENT_UPDATED */
), sl = /* @__PURE__ */ $n(
  "component:removed"
  /* COMPONENT_REMOVED */
), il = (e) => {
  je && typeof je.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !je.cleanupBuffer(e) && sl(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function $n(e) {
  return (t) => {
    lo(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const ll = /* @__PURE__ */ us(
  "perf:start"
  /* PERFORMANCE_START */
), cl = /* @__PURE__ */ us(
  "perf:end"
  /* PERFORMANCE_END */
);
function us(e) {
  return (t, o, n) => {
    lo(e, t.appContext.app, t.uid, t, o, n);
  };
}
function al(e, t, o) {
  lo(
    "component:emit",
    e.appContext.app,
    e,
    t,
    o
  );
}
let pe = null, fs = null;
function Io(e) {
  const t = pe;
  return pe = e, fs = e && e.type.__scopeId || null, t;
}
function ds(e, t = pe, o) {
  if (!t || e._n)
    return e;
  const n = (...r) => {
    n._d && fr(-1);
    const s = Io(t);
    let i;
    try {
      i = e(...r);
    } finally {
      Io(s), n._d && fr(1);
    }
    return process.env.NODE_ENV !== "production" && as(t), i;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function ps(e) {
  ei(e) && N("Do not use built-in directive ids as custom directive id: " + e);
}
function vt(e, t, o, n) {
  const r = e.dirs, s = t && t.dirs;
  for (let i = 0; i < r.length; i++) {
    const c = r[i];
    s && (c.oldValue = s[i].value);
    let f = c.dir[n];
    f && (st(), Xe(f, o, 8, [
      e.el,
      c,
      e,
      t
    ]), it());
  }
}
const ul = Symbol("_vte"), fl = (e) => e.__isTeleport;
function Mn(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Mn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function dl(e, t) {
  return k(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    ee({ name: e.name }, t, { setup: e })
  ) : e;
}
function hs(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const pl = /* @__PURE__ */ new WeakSet();
function ko(e, t, o, n, r = !1) {
  if (T(e)) {
    e.forEach(
      (C, $) => ko(
        C,
        t && (T(t) ? t[$] : t),
        o,
        n,
        r
      )
    );
    return;
  }
  if (Rt(n) && !r) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && ko(e, t, o, n.component.subTree);
    return;
  }
  const s = n.shapeFlag & 4 ? Bn(n.component) : n.el, i = r ? null : s, { i: c, r: f } = e;
  if (process.env.NODE_ENV !== "production" && !c) {
    N(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const g = t && t.r, h = c.refs === q ? c.refs = {} : c.refs, d = c.setupState, v = M(d), x = d === q ? () => !1 : (C) => process.env.NODE_ENV !== "production" && (H(v, C) && !ie(v[C]) && N(
    `Template ref "${C}" used on a non-ref value. It will not work in the production build.`
  ), pl.has(v[C])) ? !1 : H(v, C);
  if (g != null && g !== f && (Z(g) ? (h[g] = null, x(g) && (d[g] = null)) : ie(g) && (g.value = null)), k(f))
    Ft(f, c, 12, [i, h]);
  else {
    const C = Z(f), $ = ie(f);
    if (C || $) {
      const ne = () => {
        if (e.f) {
          const U = C ? x(f) ? d[f] : h[f] : f.value;
          r ? T(U) && Nn(U, s) : T(U) ? U.includes(s) || U.push(s) : C ? (h[f] = [s], x(f) && (d[f] = h[f])) : (f.value = [s], e.k && (h[e.k] = f.value));
        } else C ? (h[f] = i, x(f) && (d[f] = i)) : $ ? (f.value = i, e.k && (h[e.k] = i)) : process.env.NODE_ENV !== "production" && N("Invalid template ref type:", f, `(${typeof f})`);
      };
      i ? (ne.id = -1, Te(ne, o)) : ne();
    } else process.env.NODE_ENV !== "production" && N("Invalid template ref type:", f, `(${typeof f})`);
  }
}
so().requestIdleCallback;
so().cancelIdleCallback;
const Rt = (e) => !!e.type.__asyncLoader, Rn = (e) => e.type.__isKeepAlive;
function hl(e, t) {
  gs(e, "a", t);
}
function gl(e, t) {
  gs(e, "da", t);
}
function gs(e, t, o = ue) {
  const n = e.__wdc || (e.__wdc = () => {
    let r = o;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (qo(t, n, o), o) {
    let r = o.parent;
    for (; r && r.parent; )
      Rn(r.parent.vnode) && ml(n, t, o, r), r = r.parent;
  }
}
function ml(e, t, o, n) {
  const r = qo(
    t,
    e,
    n,
    !0
    /* prepend */
  );
  jn(() => {
    Nn(n[t], r);
  }, o);
}
function qo(e, t, o = ue, n = !1) {
  if (o) {
    const r = o[e] || (o[e] = []), s = t.__weh || (t.__weh = (...i) => {
      st();
      const c = uo(o), f = Xe(t, o, e, i);
      return c(), it(), f;
    });
    return n ? r.unshift(s) : r.push(s), s;
  } else if (process.env.NODE_ENV !== "production") {
    const r = yt(In[e].replace(/ hook$/, ""));
    N(
      `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const lt = (e) => (t, o = ue) => {
  (!no || e === "sp") && qo(e, (...n) => t(...n), o);
}, bl = lt("bm"), ms = lt("m"), vl = lt(
  "bu"
), _l = lt("u"), yl = lt(
  "bum"
), jn = lt("um"), wl = lt(
  "sp"
), El = lt("rtg"), xl = lt("rtc");
function Nl(e, t = ue) {
  qo("ec", e, t);
}
const Ol = Symbol.for("v-ndc");
function on(e, t, o, n) {
  let r;
  const s = o, i = T(e);
  if (i || Z(e)) {
    const c = i && Nt(e);
    let f = !1;
    c && (f = !we(e), e = Lo(e)), r = new Array(e.length);
    for (let g = 0, h = e.length; g < h; g++)
      r[g] = t(
        f ? be(e[g]) : e[g],
        g,
        void 0,
        s
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && N(`The v-for range expect an integer value but got ${e}.`), r = new Array(e);
    for (let c = 0; c < e; c++)
      r[c] = t(c + 1, c, void 0, s);
  } else if (J(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (c, f) => t(c, f, void 0, s)
      );
    else {
      const c = Object.keys(e);
      r = new Array(c.length);
      for (let f = 0, g = c.length; f < g; f++) {
        const h = c[f];
        r[f] = t(e[h], h, f, s);
      }
    }
  else
    r = [];
  return r;
}
function Dl(e, t, o = {}, n, r) {
  if (pe.ce || pe.parent && Rt(pe.parent) && pe.parent.ce)
    return L(), yn(
      ce,
      null,
      [Pe("slot", o, n)],
      64
    );
  let s = e[t];
  process.env.NODE_ENV !== "production" && s && s.length > 1 && (N(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), s = () => []), s && s._c && (s._d = !1), L();
  const i = s && bs(s(o)), c = o.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  i && i.key, f = yn(
    ce,
    {
      key: (c && !rt(c) ? c : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    i || [],
    i && e._ === 1 ? 64 : -2
  );
  return f.scopeId && (f.slotScopeIds = [f.scopeId + "-s"]), s && s._c && (s._d = !0), f;
}
function bs(e) {
  return e.some((t) => ao(t) ? !(t.type === De || t.type === ce && !bs(t.children)) : !0) ? e : null;
}
const hn = (e) => e ? Bs(e) ? Bn(e) : hn(e.parent) : null, Dt = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ee(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Je(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Je(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Je(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Je(e.refs) : e.refs,
    $parent: (e) => hn(e.parent),
    $root: (e) => hn(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => ys(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Ko(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = ns.bind(e.proxy)),
    $watch: (e) => rc.bind(e)
  })
), Fn = (e) => e === "_" || e === "$", nn = (e, t) => e !== q && !e.__isScriptSetup && H(e, t), vs = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: o, setupState: n, data: r, props: s, accessCache: i, type: c, appContext: f } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let g;
    if (t[0] !== "$") {
      const x = i[t];
      if (x !== void 0)
        switch (x) {
          case 1:
            return n[t];
          case 2:
            return r[t];
          case 4:
            return o[t];
          case 3:
            return s[t];
        }
      else {
        if (nn(n, t))
          return i[t] = 1, n[t];
        if (r !== q && H(r, t))
          return i[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (g = e.propsOptions[0]) && H(g, t)
        )
          return i[t] = 3, s[t];
        if (o !== q && H(o, t))
          return i[t] = 4, o[t];
        gn && (i[t] = 0);
      }
    }
    const h = Dt[t];
    let d, v;
    if (h)
      return t === "$attrs" ? (le(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Mo()) : process.env.NODE_ENV !== "production" && t === "$slots" && le(e, "get", t), h(e);
    if (
      // css module (injected by vue-loader)
      (d = c.__cssModules) && (d = d[t])
    )
      return d;
    if (o !== q && H(o, t))
      return i[t] = 4, o[t];
    if (
      // global properties
      v = f.config.globalProperties, H(v, t)
    )
      return v[t];
    process.env.NODE_ENV !== "production" && pe && (!Z(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (r !== q && Fn(t[0]) && H(r, t) ? N(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === pe && N(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, o) {
    const { data: n, setupState: r, ctx: s } = e;
    return nn(r, t) ? (r[t] = o, !0) : process.env.NODE_ENV !== "production" && r.__isScriptSetup && H(r, t) ? (N(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== q && H(n, t) ? (n[t] = o, !0) : H(e.props, t) ? (process.env.NODE_ENV !== "production" && N(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && N(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(s, t, {
      enumerable: !0,
      configurable: !0,
      value: o
    }) : s[t] = o, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: o, ctx: n, appContext: r, propsOptions: s }
  }, i) {
    let c;
    return !!o[i] || e !== q && H(e, i) || nn(t, i) || (c = s[0]) && H(c, i) || H(n, i) || H(Dt, i) || H(r.config.globalProperties, i);
  },
  defineProperty(e, t, o) {
    return o.get != null ? e._.accessCache[t] = 0 : H(o, "value") && this.set(e, t, o.value, null), Reflect.defineProperty(e, t, o);
  }
};
process.env.NODE_ENV !== "production" && (vs.ownKeys = (e) => (N(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Vl(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Dt).forEach((o) => {
    Object.defineProperty(t, o, {
      configurable: !0,
      enumerable: !1,
      get: () => Dt[o](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: ae
    });
  }), t;
}
function Sl(e) {
  const {
    ctx: t,
    propsOptions: [o]
  } = e;
  o && Object.keys(o).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: ae
    });
  });
}
function Cl(e) {
  const { ctx: t, setupState: o } = e;
  Object.keys(M(o)).forEach((n) => {
    if (!o.__isScriptSetup) {
      if (Fn(n[0])) {
        N(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => o[n],
        set: ae
      });
    }
  });
}
function er(e) {
  return T(e) ? e.reduce(
    (t, o) => (t[o] = null, t),
    {}
  ) : e;
}
function Tl() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, o) => {
    e[o] ? N(`${t} property "${o}" is already defined in ${e[o]}.`) : e[o] = t;
  };
}
let gn = !0;
function Al(e) {
  const t = ys(e), o = e.proxy, n = e.ctx;
  gn = !1, t.beforeCreate && tr(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: s,
    methods: i,
    watch: c,
    provide: f,
    inject: g,
    // lifecycle
    created: h,
    beforeMount: d,
    mounted: v,
    beforeUpdate: x,
    updated: C,
    activated: $,
    deactivated: ne,
    beforeDestroy: U,
    beforeUnmount: X,
    destroyed: D,
    unmounted: he,
    render: V,
    renderTracked: re,
    renderTriggered: fe,
    errorCaptured: G,
    serverPrefetch: Q,
    // public API
    expose: F,
    inheritAttrs: Ve,
    // assets
    components: Ee,
    directives: mt,
    filters: fo
  } = t, ze = process.env.NODE_ENV !== "production" ? Tl() : null;
  if (process.env.NODE_ENV !== "production") {
    const [R] = e.propsOptions;
    if (R)
      for (const j in R)
        ze("Props", j);
  }
  if (g && Il(g, n, ze), i)
    for (const R in i) {
      const j = i[R];
      k(j) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, R, {
        value: j.bind(o),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[R] = j.bind(o), process.env.NODE_ENV !== "production" && ze("Methods", R)) : process.env.NODE_ENV !== "production" && N(
        `Method "${R}" has type "${typeof j}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (r) {
    process.env.NODE_ENV !== "production" && !k(r) && N(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const R = r.call(o, o);
    if (process.env.NODE_ENV !== "production" && On(R) && N(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !J(R))
      process.env.NODE_ENV !== "production" && N("data() should return an object.");
    else if (e.data = Uo(R), process.env.NODE_ENV !== "production")
      for (const j in R)
        ze("Data", j), Fn(j[0]) || Object.defineProperty(n, j, {
          configurable: !0,
          enumerable: !0,
          get: () => R[j],
          set: ae
        });
  }
  if (gn = !0, s)
    for (const R in s) {
      const j = s[R], xe = k(j) ? j.bind(o, o) : k(j.get) ? j.get.bind(o, o) : ae;
      process.env.NODE_ENV !== "production" && xe === ae && N(`Computed property "${R}" has no getter.`);
      const Ct = !k(j) && k(j.set) ? j.set.bind(o) : process.env.NODE_ENV !== "production" ? () => {
        N(
          `Write operation failed: computed property "${R}" is readonly.`
        );
      } : ae, Me = te({
        get: xe,
        set: Ct
      });
      Object.defineProperty(n, R, {
        enumerable: !0,
        configurable: !0,
        get: () => Me.value,
        set: (He) => Me.value = He
      }), process.env.NODE_ENV !== "production" && ze("Computed", R);
    }
  if (c)
    for (const R in c)
      _s(c[R], n, o, R);
  if (f) {
    const R = k(f) ? f.call(o) : f;
    Reflect.ownKeys(R).forEach((j) => {
      Es(j, R[j]);
    });
  }
  h && tr(h, e, "c");
  function ge(R, j) {
    T(j) ? j.forEach((xe) => R(xe.bind(o))) : j && R(j.bind(o));
  }
  if (ge(bl, d), ge(ms, v), ge(vl, x), ge(_l, C), ge(hl, $), ge(gl, ne), ge(Nl, G), ge(xl, re), ge(El, fe), ge(yl, X), ge(jn, he), ge(wl, Q), T(F))
    if (F.length) {
      const R = e.exposed || (e.exposed = {});
      F.forEach((j) => {
        Object.defineProperty(R, j, {
          get: () => o[j],
          set: (xe) => o[j] = xe
        });
      });
    } else e.exposed || (e.exposed = {});
  V && e.render === ae && (e.render = V), Ve != null && (e.inheritAttrs = Ve), Ee && (e.components = Ee), mt && (e.directives = mt), Q && hs(e);
}
function Il(e, t, o = ae) {
  T(e) && (e = mn(e));
  for (const n in e) {
    const r = e[n];
    let s;
    J(r) ? "default" in r ? s = wo(
      r.from || n,
      r.default,
      !0
    ) : s = wo(r.from || n) : s = wo(r), ie(s) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => s.value,
      set: (i) => s.value = i
    }) : t[n] = s, process.env.NODE_ENV !== "production" && o("Inject", n);
  }
}
function tr(e, t, o) {
  Xe(
    T(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    o
  );
}
function _s(e, t, o, n) {
  let r = n.includes(".") ? Ps(o, n) : () => o[n];
  if (Z(e)) {
    const s = t[e];
    k(s) ? Vt(r, s) : process.env.NODE_ENV !== "production" && N(`Invalid watch handler specified by key "${e}"`, s);
  } else if (k(e))
    Vt(r, e.bind(o));
  else if (J(e))
    if (T(e))
      e.forEach((s) => _s(s, t, o, n));
    else {
      const s = k(e.handler) ? e.handler.bind(o) : t[e.handler];
      k(s) ? Vt(r, s, e) : process.env.NODE_ENV !== "production" && N(`Invalid watch handler specified by key "${e.handler}"`, s);
    }
  else process.env.NODE_ENV !== "production" && N(`Invalid watch option: "${n}"`, e);
}
function ys(e) {
  const t = e.type, { mixins: o, extends: n } = t, {
    mixins: r,
    optionsCache: s,
    config: { optionMergeStrategies: i }
  } = e.appContext, c = s.get(t);
  let f;
  return c ? f = c : !r.length && !o && !n ? f = t : (f = {}, r.length && r.forEach(
    (g) => Po(f, g, i, !0)
  ), Po(f, t, i)), J(t) && s.set(t, f), f;
}
function Po(e, t, o, n = !1) {
  const { mixins: r, extends: s } = t;
  s && Po(e, s, o, !0), r && r.forEach(
    (i) => Po(e, i, o, !0)
  );
  for (const i in t)
    if (n && i === "expose")
      process.env.NODE_ENV !== "production" && N(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const c = kl[i] || o && o[i];
      e[i] = c ? c(e[i], t[i]) : t[i];
    }
  return e;
}
const kl = {
  data: or,
  props: nr,
  emits: nr,
  // objects
  methods: Gt,
  computed: Gt,
  // lifecycle
  beforeCreate: _e,
  created: _e,
  beforeMount: _e,
  mounted: _e,
  beforeUpdate: _e,
  updated: _e,
  beforeDestroy: _e,
  beforeUnmount: _e,
  destroyed: _e,
  unmounted: _e,
  activated: _e,
  deactivated: _e,
  errorCaptured: _e,
  serverPrefetch: _e,
  // assets
  components: Gt,
  directives: Gt,
  // watch
  watch: $l,
  // provide / inject
  provide: or,
  inject: Pl
};
function or(e, t) {
  return t ? e ? function() {
    return ee(
      k(e) ? e.call(this, this) : e,
      k(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Pl(e, t) {
  return Gt(mn(e), mn(t));
}
function mn(e) {
  if (T(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++)
      t[e[o]] = e[o];
    return t;
  }
  return e;
}
function _e(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Gt(e, t) {
  return e ? ee(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function nr(e, t) {
  return e ? T(e) && T(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ee(
    /* @__PURE__ */ Object.create(null),
    er(e),
    er(t ?? {})
  ) : t;
}
function $l(e, t) {
  if (!e) return t;
  if (!t) return e;
  const o = ee(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    o[n] = _e(e[n], t[n]);
  return o;
}
function ws() {
  return {
    app: null,
    config: {
      isNativeTag: Xs,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Ml = 0;
function Rl(e, t) {
  return function(n, r = null) {
    k(n) || (n = ee({}, n)), r != null && !J(r) && (process.env.NODE_ENV !== "production" && N("root props passed to app.mount() must be an object."), r = null);
    const s = ws(), i = /* @__PURE__ */ new WeakSet(), c = [];
    let f = !1;
    const g = s.app = {
      _uid: Ml++,
      _component: n,
      _props: r,
      _container: null,
      _context: s,
      _instance: null,
      version: gr,
      get config() {
        return s.config;
      },
      set config(h) {
        process.env.NODE_ENV !== "production" && N(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(h, ...d) {
        return i.has(h) ? process.env.NODE_ENV !== "production" && N("Plugin has already been applied to target app.") : h && k(h.install) ? (i.add(h), h.install(g, ...d)) : k(h) ? (i.add(h), h(g, ...d)) : process.env.NODE_ENV !== "production" && N(
          'A plugin must either be a function or an object with an "install" function.'
        ), g;
      },
      mixin(h) {
        return s.mixins.includes(h) ? process.env.NODE_ENV !== "production" && N(
          "Mixin has already been applied to target app" + (h.name ? `: ${h.name}` : "")
        ) : s.mixins.push(h), g;
      },
      component(h, d) {
        return process.env.NODE_ENV !== "production" && En(h, s.config), d ? (process.env.NODE_ENV !== "production" && s.components[h] && N(`Component "${h}" has already been registered in target app.`), s.components[h] = d, g) : s.components[h];
      },
      directive(h, d) {
        return process.env.NODE_ENV !== "production" && ps(h), d ? (process.env.NODE_ENV !== "production" && s.directives[h] && N(`Directive "${h}" has already been registered in target app.`), s.directives[h] = d, g) : s.directives[h];
      },
      mount(h, d, v) {
        if (f)
          process.env.NODE_ENV !== "production" && N(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && h.__vue_app__ && N(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const x = g._ceVNode || Pe(n, r);
          return x.appContext = s, v === !0 ? v = "svg" : v === !1 && (v = void 0), process.env.NODE_ENV !== "production" && (s.reload = () => {
            e(
              gt(x),
              h,
              v
            );
          }), e(x, h, v), f = !0, g._container = h, h.__vue_app__ = g, process.env.NODE_ENV !== "production" && (g._instance = x.component, ol(g, gr)), Bn(x.component);
        }
      },
      onUnmount(h) {
        process.env.NODE_ENV !== "production" && typeof h != "function" && N(
          `Expected function as first argument to app.onUnmount(), but got ${typeof h}`
        ), c.push(h);
      },
      unmount() {
        f ? (Xe(
          c,
          g._instance,
          16
        ), e(null, g._container), process.env.NODE_ENV !== "production" && (g._instance = null, nl(g)), delete g._container.__vue_app__) : process.env.NODE_ENV !== "production" && N("Cannot unmount an app that is not mounted.");
      },
      provide(h, d) {
        return process.env.NODE_ENV !== "production" && h in s.provides && N(
          `App already provides property with key "${String(h)}". It will be overwritten with the new value.`
        ), s.provides[h] = d, g;
      },
      runWithContext(h) {
        const d = jt;
        jt = g;
        try {
          return h();
        } finally {
          jt = d;
        }
      }
    };
    return g;
  };
}
let jt = null;
function Es(e, t) {
  if (!ue)
    process.env.NODE_ENV !== "production" && N("provide() can only be used inside setup().");
  else {
    let o = ue.provides;
    const n = ue.parent && ue.parent.provides;
    n === o && (o = ue.provides = Object.create(n)), o[e] = t;
  }
}
function wo(e, t, o = !1) {
  const n = ue || pe;
  if (n || jt) {
    const r = jt ? jt._context.provides : n ? n.parent == null ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return o && k(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && N(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && N("inject() can only be used inside setup() or functional components.");
}
const xs = {}, Ns = () => Object.create(xs), Os = (e) => Object.getPrototypeOf(e) === xs;
function jl(e, t, o, n = !1) {
  const r = {}, s = Ns();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Ds(e, t, r, s);
  for (const i in e.propsOptions[0])
    i in r || (r[i] = void 0);
  process.env.NODE_ENV !== "production" && Ss(t || {}, r, e), o ? e.props = n ? r : Mi(r) : e.type.props ? e.props = r : e.props = s, e.attrs = s;
}
function Fl(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function zl(e, t, o, n) {
  const {
    props: r,
    attrs: s,
    vnode: { patchFlag: i }
  } = e, c = M(r), [f] = e.propsOptions;
  let g = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && Fl(e)) && (n || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const h = e.vnode.dynamicProps;
      for (let d = 0; d < h.length; d++) {
        let v = h[d];
        if (Go(e.emitsOptions, v))
          continue;
        const x = t[v];
        if (f)
          if (H(s, v))
            x !== s[v] && (s[v] = x, g = !0);
          else {
            const C = Oe(v);
            r[C] = bn(
              f,
              c,
              C,
              x,
              e,
              !1
            );
          }
        else
          x !== s[v] && (s[v] = x, g = !0);
      }
    }
  } else {
    Ds(e, t, r, s) && (g = !0);
    let h;
    for (const d in c)
      (!t || // for camelCase
      !H(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((h = Ie(d)) === d || !H(t, h))) && (f ? o && // for camelCase
      (o[d] !== void 0 || // for kebab-case
      o[h] !== void 0) && (r[d] = bn(
        f,
        c,
        d,
        void 0,
        e,
        !0
      )) : delete r[d]);
    if (s !== c)
      for (const d in s)
        (!t || !H(t, d)) && (delete s[d], g = !0);
  }
  g && Ge(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Ss(t || {}, r, e);
}
function Ds(e, t, o, n) {
  const [r, s] = e.propsOptions;
  let i = !1, c;
  if (t)
    for (let f in t) {
      if (Jt(f))
        continue;
      const g = t[f];
      let h;
      r && H(r, h = Oe(f)) ? !s || !s.includes(h) ? o[h] = g : (c || (c = {}))[h] = g : Go(e.emitsOptions, f) || (!(f in n) || g !== n[f]) && (n[f] = g, i = !0);
    }
  if (s) {
    const f = M(o), g = c || q;
    for (let h = 0; h < s.length; h++) {
      const d = s[h];
      o[d] = bn(
        r,
        f,
        d,
        g[d],
        e,
        !H(g, d)
      );
    }
  }
  return i;
}
function bn(e, t, o, n, r, s) {
  const i = e[o];
  if (i != null) {
    const c = H(i, "default");
    if (c && n === void 0) {
      const f = i.default;
      if (i.type !== Function && !i.skipFactory && k(f)) {
        const { propsDefaults: g } = r;
        if (o in g)
          n = g[o];
        else {
          const h = uo(r);
          n = g[o] = f.call(
            null,
            t
          ), h();
        }
      } else
        n = f;
      r.ce && r.ce._setProp(o, n);
    }
    i[
      0
      /* shouldCast */
    ] && (s && !c ? n = !1 : i[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === Ie(o)) && (n = !0));
  }
  return n;
}
const Hl = /* @__PURE__ */ new WeakMap();
function Vs(e, t, o = !1) {
  const n = o ? Hl : t.propsCache, r = n.get(e);
  if (r)
    return r;
  const s = e.props, i = {}, c = [];
  let f = !1;
  if (!k(e)) {
    const h = (d) => {
      f = !0;
      const [v, x] = Vs(d, t, !0);
      ee(i, v), x && c.push(...x);
    };
    !o && t.mixins.length && t.mixins.forEach(h), e.extends && h(e.extends), e.mixins && e.mixins.forEach(h);
  }
  if (!s && !f)
    return J(e) && n.set(e, Pt), Pt;
  if (T(s))
    for (let h = 0; h < s.length; h++) {
      process.env.NODE_ENV !== "production" && !Z(s[h]) && N("props must be strings when using array syntax.", s[h]);
      const d = Oe(s[h]);
      rr(d) && (i[d] = q);
    }
  else if (s) {
    process.env.NODE_ENV !== "production" && !J(s) && N("invalid props options", s);
    for (const h in s) {
      const d = Oe(h);
      if (rr(d)) {
        const v = s[h], x = i[d] = T(v) || k(v) ? { type: v } : ee({}, v), C = x.type;
        let $ = !1, ne = !0;
        if (T(C))
          for (let U = 0; U < C.length; ++U) {
            const X = C[U], D = k(X) && X.name;
            if (D === "Boolean") {
              $ = !0;
              break;
            } else D === "String" && (ne = !1);
          }
        else
          $ = k(C) && C.name === "Boolean";
        x[
          0
          /* shouldCast */
        ] = $, x[
          1
          /* shouldCastTrue */
        ] = ne, ($ || H(x, "default")) && c.push(d);
      }
    }
  }
  const g = [i, c];
  return J(e) && n.set(e, g), g;
}
function rr(e) {
  return e[0] !== "$" && !Jt(e) ? !0 : (process.env.NODE_ENV !== "production" && N(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Ll(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Ss(e, t, o) {
  const n = M(t), r = o.propsOptions[0], s = Object.keys(e).map((i) => Oe(i));
  for (const i in r) {
    let c = r[i];
    c != null && Bl(
      i,
      n[i],
      c,
      process.env.NODE_ENV !== "production" ? Je(n) : n,
      !s.includes(i)
    );
  }
}
function Bl(e, t, o, n, r) {
  const { type: s, required: i, validator: c, skipCheck: f } = o;
  if (i && r) {
    N('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !i)) {
    if (s != null && s !== !0 && !f) {
      let g = !1;
      const h = T(s) ? s : [s], d = [];
      for (let v = 0; v < h.length && !g; v++) {
        const { valid: x, expectedType: C } = Wl(t, h[v]);
        d.push(C || ""), g = x;
      }
      if (!g) {
        N(Kl(e, t, d));
        return;
      }
    }
    c && !c(t, n) && N('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Ul = /* @__PURE__ */ nt(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Wl(e, t) {
  let o;
  const n = Ll(t);
  if (n === "null")
    o = e === null;
  else if (Ul(n)) {
    const r = typeof e;
    o = r === n.toLowerCase(), !o && r === "object" && (o = e instanceof t);
  } else n === "Object" ? o = J(e) : n === "Array" ? o = T(e) : o = e instanceof t;
  return {
    valid: o,
    expectedType: n
  };
}
function Kl(e, t, o) {
  if (o.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${o.map(Ho).join(" | ")}`;
  const r = o[0], s = Dn(t), i = sr(t, r), c = sr(t, s);
  return o.length === 1 && ir(r) && !ql(r, s) && (n += ` with value ${i}`), n += `, got ${s} `, ir(s) && (n += `with value ${c}.`), n;
}
function sr(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function ir(e) {
  return ["string", "number", "boolean"].some((o) => e.toLowerCase() === o);
}
function ql(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Cs = (e) => e[0] === "_" || e === "$stable", zn = (e) => T(e) ? e.map(Re) : [Re(e)], Gl = (e, t, o) => {
  if (t._n)
    return t;
  const n = ds((...r) => (process.env.NODE_ENV !== "production" && ue && (!o || o.root === ue.root) && N(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), zn(t(...r))), o);
  return n._c = !1, n;
}, Ts = (e, t, o) => {
  const n = e._ctx;
  for (const r in e) {
    if (Cs(r)) continue;
    const s = e[r];
    if (k(s))
      t[r] = Gl(r, s, n);
    else if (s != null) {
      process.env.NODE_ENV !== "production" && N(
        `Non-function value encountered for slot "${r}". Prefer function slots for better performance.`
      );
      const i = zn(s);
      t[r] = () => i;
    }
  }
}, As = (e, t) => {
  process.env.NODE_ENV !== "production" && !Rn(e.vnode) && N(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const o = zn(t);
  e.slots.default = () => o;
}, vn = (e, t, o) => {
  for (const n in t)
    (o || n !== "_") && (e[n] = t[n]);
}, Jl = (e, t, o) => {
  const n = e.slots = Ns();
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (vn(n, t, o), o && Vo(n, "_", r, !0)) : Ts(t, n);
  } else t && As(e, t);
}, Yl = (e, t, o) => {
  const { vnode: n, slots: r } = e;
  let s = !0, i = q;
  if (n.shapeFlag & 32) {
    const c = t._;
    c ? process.env.NODE_ENV !== "production" && Ye ? (vn(r, t, o), Ge(e, "set", "$slots")) : o && c === 1 ? s = !1 : vn(r, t, o) : (s = !t.$stable, Ts(t, r)), i = t;
  } else t && (As(e, t), i = { default: 1 });
  if (s)
    for (const c in r)
      !Cs(c) && i[c] == null && delete r[c];
};
let Wt, pt;
function At(e, t) {
  e.appContext.config.performance && $o() && pt.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && ll(e, t, $o() ? pt.now() : Date.now());
}
function It(e, t) {
  if (e.appContext.config.performance && $o()) {
    const o = `vue-${t}-${e.uid}`, n = o + ":end";
    pt.mark(n), pt.measure(
      `<${Jo(e, e.type)}> ${t}`,
      o,
      n
    ), pt.clearMarks(o), pt.clearMarks(n);
  }
  process.env.NODE_ENV !== "production" && cl(e, t, $o() ? pt.now() : Date.now());
}
function $o() {
  return Wt !== void 0 || (typeof window < "u" && window.performance ? (Wt = !0, pt = window.performance) : Wt = !1), Wt;
}
function Ql() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Te = fc;
function Xl(e) {
  return Zl(e);
}
function Zl(e, t) {
  Ql();
  const o = so();
  o.__VUE__ = !0, process.env.NODE_ENV !== "production" && Pn(o.__VUE_DEVTOOLS_GLOBAL_HOOK__, o);
  const {
    insert: n,
    remove: r,
    patchProp: s,
    createElement: i,
    createText: c,
    createComment: f,
    setText: g,
    setElementText: h,
    parentNode: d,
    nextSibling: v,
    setScopeId: x = ae,
    insertStaticContent: C
  } = e, $ = (a, l, u, p = null, m = null, b = null, E = void 0, _ = null, w = process.env.NODE_ENV !== "production" && Ye ? !1 : !!l.dynamicChildren) => {
    if (a === l)
      return;
    a && !Kt(a, l) && (p = bt(a), Le(a, m, b, !0), a = null), l.patchFlag === -2 && (w = !1, l.dynamicChildren = null);
    const { type: y, ref: A, shapeFlag: O } = l;
    switch (y) {
      case co:
        ne(a, l, u, p);
        break;
      case De:
        U(a, l, u, p);
        break;
      case xo:
        a == null ? X(l, u, p, E) : process.env.NODE_ENV !== "production" && D(a, l, u, E);
        break;
      case ce:
        mt(
          a,
          l,
          u,
          p,
          m,
          b,
          E,
          _,
          w
        );
        break;
      default:
        O & 1 ? re(
          a,
          l,
          u,
          p,
          m,
          b,
          E,
          _,
          w
        ) : O & 6 ? fo(
          a,
          l,
          u,
          p,
          m,
          b,
          E,
          _,
          w
        ) : O & 64 || O & 128 ? y.process(
          a,
          l,
          u,
          p,
          m,
          b,
          E,
          _,
          w,
          Ze
        ) : process.env.NODE_ENV !== "production" && N("Invalid VNode type:", y, `(${typeof y})`);
    }
    A != null && m && ko(A, a && a.ref, b, l || a, !l);
  }, ne = (a, l, u, p) => {
    if (a == null)
      n(
        l.el = c(l.children),
        u,
        p
      );
    else {
      const m = l.el = a.el;
      l.children !== a.children && g(m, l.children);
    }
  }, U = (a, l, u, p) => {
    a == null ? n(
      l.el = f(l.children || ""),
      u,
      p
    ) : l.el = a.el;
  }, X = (a, l, u, p) => {
    [a.el, a.anchor] = C(
      a.children,
      l,
      u,
      p,
      a.el,
      a.anchor
    );
  }, D = (a, l, u, p) => {
    if (l.children !== a.children) {
      const m = v(a.anchor);
      V(a), [l.el, l.anchor] = C(
        l.children,
        u,
        m,
        p
      );
    } else
      l.el = a.el, l.anchor = a.anchor;
  }, he = ({ el: a, anchor: l }, u, p) => {
    let m;
    for (; a && a !== l; )
      m = v(a), n(a, u, p), a = m;
    n(l, u, p);
  }, V = ({ el: a, anchor: l }) => {
    let u;
    for (; a && a !== l; )
      u = v(a), r(a), a = u;
    r(l);
  }, re = (a, l, u, p, m, b, E, _, w) => {
    l.type === "svg" ? E = "svg" : l.type === "math" && (E = "mathml"), a == null ? fe(
      l,
      u,
      p,
      m,
      b,
      E,
      _,
      w
    ) : F(
      a,
      l,
      m,
      b,
      E,
      _,
      w
    );
  }, fe = (a, l, u, p, m, b, E, _) => {
    let w, y;
    const { props: A, shapeFlag: O, transition: S, dirs: P } = a;
    if (w = a.el = i(
      a.type,
      b,
      A && A.is,
      A
    ), O & 8 ? h(w, a.children) : O & 16 && Q(
      a.children,
      w,
      null,
      p,
      m,
      rn(a, b),
      E,
      _
    ), P && vt(a, null, p, "created"), G(w, a, a.scopeId, E, p), A) {
      for (const Y in A)
        Y !== "value" && !Jt(Y) && s(w, Y, null, A[Y], b, p);
      "value" in A && s(w, "value", null, A.value, b), (y = A.onVnodeBeforeMount) && Ke(y, p, a);
    }
    process.env.NODE_ENV !== "production" && (Vo(w, "__vnode", a, !0), Vo(w, "__vueParentComponent", p, !0)), P && vt(a, null, p, "beforeMount");
    const z = ec(m, S);
    z && S.beforeEnter(w), n(w, l, u), ((y = A && A.onVnodeMounted) || z || P) && Te(() => {
      y && Ke(y, p, a), z && S.enter(w), P && vt(a, null, p, "mounted");
    }, m);
  }, G = (a, l, u, p, m) => {
    if (u && x(a, u), p)
      for (let b = 0; b < p.length; b++)
        x(a, p[b]);
    if (m) {
      let b = m.subTree;
      if (process.env.NODE_ENV !== "production" && b.patchFlag > 0 && b.patchFlag & 2048 && (b = Hn(b.children) || b), l === b || Rs(b.type) && (b.ssContent === l || b.ssFallback === l)) {
        const E = m.vnode;
        G(
          a,
          E,
          E.scopeId,
          E.slotScopeIds,
          m.parent
        );
      }
    }
  }, Q = (a, l, u, p, m, b, E, _, w = 0) => {
    for (let y = w; y < a.length; y++) {
      const A = a[y] = _ ? ft(a[y]) : Re(a[y]);
      $(
        null,
        A,
        l,
        u,
        p,
        m,
        b,
        E,
        _
      );
    }
  }, F = (a, l, u, p, m, b, E) => {
    const _ = l.el = a.el;
    process.env.NODE_ENV !== "production" && (_.__vnode = l);
    let { patchFlag: w, dynamicChildren: y, dirs: A } = l;
    w |= a.patchFlag & 16;
    const O = a.props || q, S = l.props || q;
    let P;
    if (u && _t(u, !1), (P = S.onVnodeBeforeUpdate) && Ke(P, u, l, a), A && vt(l, a, u, "beforeUpdate"), u && _t(u, !0), process.env.NODE_ENV !== "production" && Ye && (w = 0, E = !1, y = null), (O.innerHTML && S.innerHTML == null || O.textContent && S.textContent == null) && h(_, ""), y ? (Ve(
      a.dynamicChildren,
      y,
      _,
      u,
      p,
      rn(l, m),
      b
    ), process.env.NODE_ENV !== "production" && Eo(a, l)) : E || xe(
      a,
      l,
      _,
      null,
      u,
      p,
      rn(l, m),
      b,
      !1
    ), w > 0) {
      if (w & 16)
        Ee(_, O, S, u, m);
      else if (w & 2 && O.class !== S.class && s(_, "class", null, S.class, m), w & 4 && s(_, "style", O.style, S.style, m), w & 8) {
        const z = l.dynamicProps;
        for (let Y = 0; Y < z.length; Y++) {
          const W = z[Y], Ce = O[W], Ne = S[W];
          (Ne !== Ce || W === "value") && s(_, W, Ce, Ne, m, u);
        }
      }
      w & 1 && a.children !== l.children && h(_, l.children);
    } else !E && y == null && Ee(_, O, S, u, m);
    ((P = S.onVnodeUpdated) || A) && Te(() => {
      P && Ke(P, u, l, a), A && vt(l, a, u, "updated");
    }, p);
  }, Ve = (a, l, u, p, m, b, E) => {
    for (let _ = 0; _ < l.length; _++) {
      const w = a[_], y = l[_], A = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        w.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (w.type === ce || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Kt(w, y) || // - In the case of a component, it could contain anything.
        w.shapeFlag & 70) ? d(w.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          u
        )
      );
      $(
        w,
        y,
        A,
        null,
        p,
        m,
        b,
        E,
        !0
      );
    }
  }, Ee = (a, l, u, p, m) => {
    if (l !== u) {
      if (l !== q)
        for (const b in l)
          !Jt(b) && !(b in u) && s(
            a,
            b,
            l[b],
            null,
            m,
            p
          );
      for (const b in u) {
        if (Jt(b)) continue;
        const E = u[b], _ = l[b];
        E !== _ && b !== "value" && s(a, b, _, E, m, p);
      }
      "value" in u && s(a, "value", l.value, u.value, m);
    }
  }, mt = (a, l, u, p, m, b, E, _, w) => {
    const y = l.el = a ? a.el : c(""), A = l.anchor = a ? a.anchor : c("");
    let { patchFlag: O, dynamicChildren: S, slotScopeIds: P } = l;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (Ye || O & 2048) && (O = 0, w = !1, S = null), P && (_ = _ ? _.concat(P) : P), a == null ? (n(y, u, p), n(A, u, p), Q(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      l.children || [],
      u,
      A,
      m,
      b,
      E,
      _,
      w
    )) : O > 0 && O & 64 && S && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    a.dynamicChildren ? (Ve(
      a.dynamicChildren,
      S,
      u,
      m,
      b,
      E,
      _
    ), process.env.NODE_ENV !== "production" ? Eo(a, l) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (l.key != null || m && l === m.subTree) && Eo(
        a,
        l,
        !0
        /* shallow */
      )
    )) : xe(
      a,
      l,
      u,
      A,
      m,
      b,
      E,
      _,
      w
    );
  }, fo = (a, l, u, p, m, b, E, _, w) => {
    l.slotScopeIds = _, a == null ? l.shapeFlag & 512 ? m.ctx.activate(
      l,
      u,
      p,
      E,
      w
    ) : ze(
      l,
      u,
      p,
      m,
      b,
      E,
      w
    ) : ge(a, l, w);
  }, ze = (a, l, u, p, m, b, E) => {
    const _ = a.component = vc(
      a,
      p,
      m
    );
    if (process.env.NODE_ENV !== "production" && _.type.__hmrId && Xi(_), process.env.NODE_ENV !== "production" && (vo(a), At(_, "mount")), Rn(a) && (_.ctx.renderer = Ze), process.env.NODE_ENV !== "production" && At(_, "init"), wc(_, !1, E), process.env.NODE_ENV !== "production" && It(_, "init"), _.asyncDep) {
      if (process.env.NODE_ENV !== "production" && Ye && (a.el = null), m && m.registerDep(_, R, E), !a.el) {
        const w = _.subTree = Pe(De);
        U(null, w, l, u);
      }
    } else
      R(
        _,
        a,
        l,
        u,
        m,
        b,
        E
      );
    process.env.NODE_ENV !== "production" && (_o(), It(_, "mount"));
  }, ge = (a, l, u) => {
    const p = l.component = a.component;
    if (ac(a, l, u))
      if (p.asyncDep && !p.asyncResolved) {
        process.env.NODE_ENV !== "production" && vo(l), j(p, l, u), process.env.NODE_ENV !== "production" && _o();
        return;
      } else
        p.next = l, p.update();
    else
      l.el = a.el, p.vnode = l;
  }, R = (a, l, u, p, m, b, E) => {
    const _ = () => {
      if (a.isMounted) {
        let { next: O, bu: S, u: P, parent: z, vnode: Y } = a;
        {
          const Ue = Is(a);
          if (Ue) {
            O && (O.el = Y.el, j(a, O, E)), Ue.asyncDep.then(() => {
              a.isUnmounted || _();
            });
            return;
          }
        }
        let W = O, Ce;
        process.env.NODE_ENV !== "production" && vo(O || a.vnode), _t(a, !1), O ? (O.el = Y.el, j(a, O, E)) : O = Y, S && Bt(S), (Ce = O.props && O.props.onVnodeBeforeUpdate) && Ke(Ce, z, O, Y), _t(a, !0), process.env.NODE_ENV !== "production" && At(a, "render");
        const Ne = cr(a);
        process.env.NODE_ENV !== "production" && It(a, "render");
        const Be = a.subTree;
        a.subTree = Ne, process.env.NODE_ENV !== "production" && At(a, "patch"), $(
          Be,
          Ne,
          // parent may have changed if it's in a teleport
          d(Be.el),
          // anchor may have changed if it's in a fragment
          bt(Be),
          a,
          m,
          b
        ), process.env.NODE_ENV !== "production" && It(a, "patch"), O.el = Ne.el, W === null && uc(a, Ne.el), P && Te(P, m), (Ce = O.props && O.props.onVnodeUpdated) && Te(
          () => Ke(Ce, z, O, Y),
          m
        ), process.env.NODE_ENV !== "production" && as(a), process.env.NODE_ENV !== "production" && _o();
      } else {
        let O;
        const { el: S, props: P } = l, { bm: z, m: Y, parent: W, root: Ce, type: Ne } = a, Be = Rt(l);
        _t(a, !1), z && Bt(z), !Be && (O = P && P.onVnodeBeforeMount) && Ke(O, W, l), _t(a, !0);
        {
          Ce.ce && Ce.ce._injectChildStyle(Ne), process.env.NODE_ENV !== "production" && At(a, "render");
          const Ue = a.subTree = cr(a);
          process.env.NODE_ENV !== "production" && It(a, "render"), process.env.NODE_ENV !== "production" && At(a, "patch"), $(
            null,
            Ue,
            u,
            p,
            a,
            m,
            b
          ), process.env.NODE_ENV !== "production" && It(a, "patch"), l.el = Ue.el;
        }
        if (Y && Te(Y, m), !Be && (O = P && P.onVnodeMounted)) {
          const Ue = l;
          Te(
            () => Ke(O, W, Ue),
            m
          );
        }
        (l.shapeFlag & 256 || W && Rt(W.vnode) && W.vnode.shapeFlag & 256) && a.a && Te(a.a, m), a.isMounted = !0, process.env.NODE_ENV !== "production" && rl(a), l = u = p = null;
      }
    };
    a.scope.on();
    const w = a.effect = new Mr(_);
    a.scope.off();
    const y = a.update = w.run.bind(w), A = a.job = w.runIfDirty.bind(w);
    A.i = a, A.id = a.uid, w.scheduler = () => Ko(A), _t(a, !0), process.env.NODE_ENV !== "production" && (w.onTrack = a.rtc ? (O) => Bt(a.rtc, O) : void 0, w.onTrigger = a.rtg ? (O) => Bt(a.rtg, O) : void 0), y();
  }, j = (a, l, u) => {
    l.component = a;
    const p = a.vnode.props;
    a.vnode = l, a.next = null, zl(a, l.props, p, u), Yl(a, l.children, u), st(), Xn(a), it();
  }, xe = (a, l, u, p, m, b, E, _, w = !1) => {
    const y = a && a.children, A = a ? a.shapeFlag : 0, O = l.children, { patchFlag: S, shapeFlag: P } = l;
    if (S > 0) {
      if (S & 128) {
        Me(
          y,
          O,
          u,
          p,
          m,
          b,
          E,
          _,
          w
        );
        return;
      } else if (S & 256) {
        Ct(
          y,
          O,
          u,
          p,
          m,
          b,
          E,
          _,
          w
        );
        return;
      }
    }
    P & 8 ? (A & 16 && ct(y, m, b), O !== y && h(u, O)) : A & 16 ? P & 16 ? Me(
      y,
      O,
      u,
      p,
      m,
      b,
      E,
      _,
      w
    ) : ct(y, m, b, !0) : (A & 8 && h(u, ""), P & 16 && Q(
      O,
      u,
      p,
      m,
      b,
      E,
      _,
      w
    ));
  }, Ct = (a, l, u, p, m, b, E, _, w) => {
    a = a || Pt, l = l || Pt;
    const y = a.length, A = l.length, O = Math.min(y, A);
    let S;
    for (S = 0; S < O; S++) {
      const P = l[S] = w ? ft(l[S]) : Re(l[S]);
      $(
        a[S],
        P,
        u,
        null,
        m,
        b,
        E,
        _,
        w
      );
    }
    y > A ? ct(
      a,
      m,
      b,
      !0,
      !1,
      O
    ) : Q(
      l,
      u,
      p,
      m,
      b,
      E,
      _,
      w,
      O
    );
  }, Me = (a, l, u, p, m, b, E, _, w) => {
    let y = 0;
    const A = l.length;
    let O = a.length - 1, S = A - 1;
    for (; y <= O && y <= S; ) {
      const P = a[y], z = l[y] = w ? ft(l[y]) : Re(l[y]);
      if (Kt(P, z))
        $(
          P,
          z,
          u,
          null,
          m,
          b,
          E,
          _,
          w
        );
      else
        break;
      y++;
    }
    for (; y <= O && y <= S; ) {
      const P = a[O], z = l[S] = w ? ft(l[S]) : Re(l[S]);
      if (Kt(P, z))
        $(
          P,
          z,
          u,
          null,
          m,
          b,
          E,
          _,
          w
        );
      else
        break;
      O--, S--;
    }
    if (y > O) {
      if (y <= S) {
        const P = S + 1, z = P < A ? l[P].el : p;
        for (; y <= S; )
          $(
            null,
            l[y] = w ? ft(l[y]) : Re(l[y]),
            u,
            z,
            m,
            b,
            E,
            _,
            w
          ), y++;
      }
    } else if (y > S)
      for (; y <= O; )
        Le(a[y], m, b, !0), y++;
    else {
      const P = y, z = y, Y = /* @__PURE__ */ new Map();
      for (y = z; y <= S; y++) {
        const ve = l[y] = w ? ft(l[y]) : Re(l[y]);
        ve.key != null && (process.env.NODE_ENV !== "production" && Y.has(ve.key) && N(
          "Duplicate keys found during update:",
          JSON.stringify(ve.key),
          "Make sure keys are unique."
        ), Y.set(ve.key, y));
      }
      let W, Ce = 0;
      const Ne = S - z + 1;
      let Be = !1, Ue = 0;
      const Lt = new Array(Ne);
      for (y = 0; y < Ne; y++) Lt[y] = 0;
      for (y = P; y <= O; y++) {
        const ve = a[y];
        if (Ce >= Ne) {
          Le(ve, m, b, !0);
          continue;
        }
        let We;
        if (ve.key != null)
          We = Y.get(ve.key);
        else
          for (W = z; W <= S; W++)
            if (Lt[W - z] === 0 && Kt(ve, l[W])) {
              We = W;
              break;
            }
        We === void 0 ? Le(ve, m, b, !0) : (Lt[We - z] = y + 1, We >= Ue ? Ue = We : Be = !0, $(
          ve,
          l[We],
          u,
          null,
          m,
          b,
          E,
          _,
          w
        ), Ce++);
      }
      const Wn = Be ? tc(Lt) : Pt;
      for (W = Wn.length - 1, y = Ne - 1; y >= 0; y--) {
        const ve = z + y, We = l[ve], Kn = ve + 1 < A ? l[ve + 1].el : p;
        Lt[y] === 0 ? $(
          null,
          We,
          u,
          Kn,
          m,
          b,
          E,
          _,
          w
        ) : Be && (W < 0 || y !== Wn[W] ? He(We, u, Kn, 2) : W--);
      }
    }
  }, He = (a, l, u, p, m = null) => {
    const { el: b, type: E, transition: _, children: w, shapeFlag: y } = a;
    if (y & 6) {
      He(a.component.subTree, l, u, p);
      return;
    }
    if (y & 128) {
      a.suspense.move(l, u, p);
      return;
    }
    if (y & 64) {
      E.move(a, l, u, Ze);
      return;
    }
    if (E === ce) {
      n(b, l, u);
      for (let O = 0; O < w.length; O++)
        He(w[O], l, u, p);
      n(a.anchor, l, u);
      return;
    }
    if (E === xo) {
      he(a, l, u);
      return;
    }
    if (p !== 2 && y & 1 && _)
      if (p === 0)
        _.beforeEnter(b), n(b, l, u), Te(() => _.enter(b), m);
      else {
        const { leave: O, delayLeave: S, afterLeave: P } = _, z = () => n(b, l, u), Y = () => {
          O(b, () => {
            z(), P && P();
          });
        };
        S ? S(b, z, Y) : Y();
      }
    else
      n(b, l, u);
  }, Le = (a, l, u, p = !1, m = !1) => {
    const {
      type: b,
      props: E,
      ref: _,
      children: w,
      dynamicChildren: y,
      shapeFlag: A,
      patchFlag: O,
      dirs: S,
      cacheIndex: P
    } = a;
    if (O === -2 && (m = !1), _ != null && ko(_, null, u, a, !0), P != null && (l.renderCache[P] = void 0), A & 256) {
      l.ctx.deactivate(a);
      return;
    }
    const z = A & 1 && S, Y = !Rt(a);
    let W;
    if (Y && (W = E && E.onVnodeBeforeUnmount) && Ke(W, l, a), A & 6)
      po(a.component, u, p);
    else {
      if (A & 128) {
        a.suspense.unmount(u, p);
        return;
      }
      z && vt(a, null, l, "beforeUnmount"), A & 64 ? a.type.remove(
        a,
        l,
        u,
        Ze,
        p
      ) : y && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !y.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (b !== ce || O > 0 && O & 64) ? ct(
        y,
        l,
        u,
        !1,
        !0
      ) : (b === ce && O & 384 || !m && A & 16) && ct(w, l, u), p && zt(a);
    }
    (Y && (W = E && E.onVnodeUnmounted) || z) && Te(() => {
      W && Ke(W, l, a), z && vt(a, null, l, "unmounted");
    }, u);
  }, zt = (a) => {
    const { type: l, el: u, anchor: p, transition: m } = a;
    if (l === ce) {
      process.env.NODE_ENV !== "production" && a.patchFlag > 0 && a.patchFlag & 2048 && m && !m.persisted ? a.children.forEach((E) => {
        E.type === De ? r(E.el) : zt(E);
      }) : Se(u, p);
      return;
    }
    if (l === xo) {
      V(a);
      return;
    }
    const b = () => {
      r(u), m && !m.persisted && m.afterLeave && m.afterLeave();
    };
    if (a.shapeFlag & 1 && m && !m.persisted) {
      const { leave: E, delayLeave: _ } = m, w = () => E(u, b);
      _ ? _(a.el, b, w) : w();
    } else
      b();
  }, Se = (a, l) => {
    let u;
    for (; a !== l; )
      u = v(a), r(a), a = u;
    r(l);
  }, po = (a, l, u) => {
    process.env.NODE_ENV !== "production" && a.type.__hmrId && Zi(a);
    const { bum: p, scope: m, job: b, subTree: E, um: _, m: w, a: y } = a;
    lr(w), lr(y), p && Bt(p), m.stop(), b && (b.flags |= 8, Le(E, a, l, u)), _ && Te(_, l), Te(() => {
      a.isUnmounted = !0;
    }, l), l && l.pendingBranch && !l.isUnmounted && a.asyncDep && !a.asyncResolved && a.suspenseId === l.pendingId && (l.deps--, l.deps === 0 && l.resolve()), process.env.NODE_ENV !== "production" && il(a);
  }, ct = (a, l, u, p = !1, m = !1, b = 0) => {
    for (let E = b; E < a.length; E++)
      Le(a[E], l, u, p, m);
  }, bt = (a) => {
    if (a.shapeFlag & 6)
      return bt(a.component.subTree);
    if (a.shapeFlag & 128)
      return a.suspense.next();
    const l = v(a.anchor || a.el), u = l && l[ul];
    return u ? v(u) : l;
  };
  let Ht = !1;
  const ho = (a, l, u) => {
    a == null ? l._vnode && Le(l._vnode, null, null, !0) : $(
      l._vnode || null,
      a,
      l,
      null,
      null,
      null,
      u
    ), l._vnode = a, Ht || (Ht = !0, Xn(), is(), Ht = !1);
  }, Ze = {
    p: $,
    um: Le,
    m: He,
    r: zt,
    mt: ze,
    mc: Q,
    pc: xe,
    pbc: Ve,
    n: bt,
    o: e
  };
  return {
    render: ho,
    hydrate: void 0,
    createApp: Rl(ho)
  };
}
function rn({ type: e, props: t }, o) {
  return o === "svg" && e === "foreignObject" || o === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : o;
}
function _t({ effect: e, job: t }, o) {
  o ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function ec(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Eo(e, t, o = !1) {
  const n = e.children, r = t.children;
  if (T(n) && T(r))
    for (let s = 0; s < n.length; s++) {
      const i = n[s];
      let c = r[s];
      c.shapeFlag & 1 && !c.dynamicChildren && ((c.patchFlag <= 0 || c.patchFlag === 32) && (c = r[s] = ft(r[s]), c.el = i.el), !o && c.patchFlag !== -2 && Eo(i, c)), c.type === co && (c.el = i.el), process.env.NODE_ENV !== "production" && c.type === De && !c.el && (c.el = i.el);
    }
}
function tc(e) {
  const t = e.slice(), o = [0];
  let n, r, s, i, c;
  const f = e.length;
  for (n = 0; n < f; n++) {
    const g = e[n];
    if (g !== 0) {
      if (r = o[o.length - 1], e[r] < g) {
        t[n] = r, o.push(n);
        continue;
      }
      for (s = 0, i = o.length - 1; s < i; )
        c = s + i >> 1, e[o[c]] < g ? s = c + 1 : i = c;
      g < e[o[s]] && (s > 0 && (t[n] = o[s - 1]), o[s] = n);
    }
  }
  for (s = o.length, i = o[s - 1]; s-- > 0; )
    o[s] = i, i = t[i];
  return o;
}
function Is(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Is(t);
}
function lr(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const oc = Symbol.for("v-scx"), nc = () => {
  {
    const e = wo(oc);
    return e || process.env.NODE_ENV !== "production" && N(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Vt(e, t, o) {
  return process.env.NODE_ENV !== "production" && !k(t) && N(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), ks(e, t, o);
}
function ks(e, t, o = q) {
  const { immediate: n, deep: r, flush: s, once: i } = o;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && N(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && N(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), i !== void 0 && N(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const c = ee({}, o);
  process.env.NODE_ENV !== "production" && (c.onWarn = N);
  const f = t && n || !t && s !== "post";
  let g;
  if (no) {
    if (s === "sync") {
      const x = nc();
      g = x.__watcherHandles || (x.__watcherHandles = []);
    } else if (!f) {
      const x = () => {
      };
      return x.stop = ae, x.resume = ae, x.pause = ae, x;
    }
  }
  const h = ue;
  c.call = (x, C, $) => Xe(x, h, C, $);
  let d = !1;
  s === "post" ? c.scheduler = (x) => {
    Te(x, h && h.suspense);
  } : s !== "sync" && (d = !0, c.scheduler = (x, C) => {
    C ? x() : Ko(x);
  }), c.augmentJob = (x) => {
    t && (x.flags |= 4), d && (x.flags |= 2, h && (x.id = h.uid, x.i = h));
  };
  const v = Ui(e, t, c);
  return no && (g ? g.push(v) : f && v()), v;
}
function rc(e, t, o) {
  const n = this.proxy, r = Z(e) ? e.includes(".") ? Ps(n, e) : () => n[e] : e.bind(n, n);
  let s;
  k(t) ? s = t : (s = t.handler, o = t);
  const i = uo(this), c = ks(r, s.bind(n), o);
  return i(), c;
}
function Ps(e, t) {
  const o = t.split(".");
  return () => {
    let n = e;
    for (let r = 0; r < o.length && n; r++)
      n = n[o[r]];
    return n;
  };
}
const sc = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Oe(t)}Modifiers`] || e[`${Ie(t)}Modifiers`];
function ic(e, t, ...o) {
  if (e.isUnmounted) return;
  const n = e.vnode.props || q;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: h,
      propsOptions: [d]
    } = e;
    if (h)
      if (!(t in h))
        (!d || !(yt(Oe(t)) in d)) && N(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${yt(Oe(t))}" prop.`
        );
      else {
        const v = h[t];
        k(v) && (v(...o) || N(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let r = o;
  const s = t.startsWith("update:"), i = s && sc(n, t.slice(7));
  if (i && (i.trim && (r = o.map((h) => Z(h) ? h.trim() : h)), i.number && (r = o.map(ni))), process.env.NODE_ENV !== "production" && al(e, t, r), process.env.NODE_ENV !== "production") {
    const h = t.toLowerCase();
    h !== t && n[yt(h)] && N(
      `Event "${h}" is emitted in component ${Jo(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${Ie(
        t
      )}" instead of "${t}".`
    );
  }
  let c, f = n[c = yt(t)] || // also try camelCase event handler (#2249)
  n[c = yt(Oe(t))];
  !f && s && (f = n[c = yt(Ie(t))]), f && Xe(
    f,
    e,
    6,
    r
  );
  const g = n[c + "Once"];
  if (g) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[c])
      return;
    e.emitted[c] = !0, Xe(
      g,
      e,
      6,
      r
    );
  }
}
function $s(e, t, o = !1) {
  const n = t.emitsCache, r = n.get(e);
  if (r !== void 0)
    return r;
  const s = e.emits;
  let i = {}, c = !1;
  if (!k(e)) {
    const f = (g) => {
      const h = $s(g, t, !0);
      h && (c = !0, ee(i, h));
    };
    !o && t.mixins.length && t.mixins.forEach(f), e.extends && f(e.extends), e.mixins && e.mixins.forEach(f);
  }
  return !s && !c ? (J(e) && n.set(e, null), null) : (T(s) ? s.forEach((f) => i[f] = null) : ee(i, s), J(e) && n.set(e, i), i);
}
function Go(e, t) {
  return !e || !ro(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), H(e, t[0].toLowerCase() + t.slice(1)) || H(e, Ie(t)) || H(e, t));
}
let _n = !1;
function Mo() {
  _n = !0;
}
function cr(e) {
  const {
    type: t,
    vnode: o,
    proxy: n,
    withProxy: r,
    propsOptions: [s],
    slots: i,
    attrs: c,
    emit: f,
    render: g,
    renderCache: h,
    props: d,
    data: v,
    setupState: x,
    ctx: C,
    inheritAttrs: $
  } = e, ne = Io(e);
  let U, X;
  process.env.NODE_ENV !== "production" && (_n = !1);
  try {
    if (o.shapeFlag & 4) {
      const V = r || n, re = process.env.NODE_ENV !== "production" && x.__isScriptSetup ? new Proxy(V, {
        get(fe, G, Q) {
          return N(
            `Property '${String(
              G
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(fe, G, Q);
        }
      }) : V;
      U = Re(
        g.call(
          re,
          V,
          h,
          process.env.NODE_ENV !== "production" ? Je(d) : d,
          x,
          v,
          C
        )
      ), X = c;
    } else {
      const V = t;
      process.env.NODE_ENV !== "production" && c === d && Mo(), U = Re(
        V.length > 1 ? V(
          process.env.NODE_ENV !== "production" ? Je(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Mo(), Je(c);
            },
            slots: i,
            emit: f
          } : { attrs: c, slots: i, emit: f }
        ) : V(
          process.env.NODE_ENV !== "production" ? Je(d) : d,
          null
        )
      ), X = t.props ? c : lc(c);
    }
  } catch (V) {
    Xt.length = 0, io(V, e, 1), U = Pe(De);
  }
  let D = U, he;
  if (process.env.NODE_ENV !== "production" && U.patchFlag > 0 && U.patchFlag & 2048 && ([D, he] = Ms(U)), X && $ !== !1) {
    const V = Object.keys(X), { shapeFlag: re } = D;
    if (V.length) {
      if (re & 7)
        s && V.some(Do) && (X = cc(
          X,
          s
        )), D = gt(D, X, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !_n && D.type !== De) {
        const fe = Object.keys(c), G = [], Q = [];
        for (let F = 0, Ve = fe.length; F < Ve; F++) {
          const Ee = fe[F];
          ro(Ee) ? Do(Ee) || G.push(Ee[2].toLowerCase() + Ee.slice(3)) : Q.push(Ee);
        }
        Q.length && N(
          `Extraneous non-props attributes (${Q.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), G.length && N(
          `Extraneous non-emits event listeners (${G.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return o.dirs && (process.env.NODE_ENV !== "production" && !ar(D) && N(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), D = gt(D, null, !1, !0), D.dirs = D.dirs ? D.dirs.concat(o.dirs) : o.dirs), o.transition && (process.env.NODE_ENV !== "production" && !ar(D) && N(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), Mn(D, o.transition)), process.env.NODE_ENV !== "production" && he ? he(D) : U = D, Io(ne), U;
}
const Ms = (e) => {
  const t = e.children, o = e.dynamicChildren, n = Hn(t, !1);
  if (n) {
    if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048)
      return Ms(n);
  } else return [e, void 0];
  const r = t.indexOf(n), s = o ? o.indexOf(n) : -1, i = (c) => {
    t[r] = c, o && (s > -1 ? o[s] = c : c.patchFlag > 0 && (e.dynamicChildren = [...o, c]));
  };
  return [Re(n), i];
};
function Hn(e, t = !0) {
  let o;
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (ao(r)) {
      if (r.type !== De || r.children === "v-if") {
        if (o)
          return;
        if (o = r, process.env.NODE_ENV !== "production" && t && o.patchFlag > 0 && o.patchFlag & 2048)
          return Hn(o.children);
      }
    } else
      return;
  }
  return o;
}
const lc = (e) => {
  let t;
  for (const o in e)
    (o === "class" || o === "style" || ro(o)) && ((t || (t = {}))[o] = e[o]);
  return t;
}, cc = (e, t) => {
  const o = {};
  for (const n in e)
    (!Do(n) || !(n.slice(9) in t)) && (o[n] = e[n]);
  return o;
}, ar = (e) => e.shapeFlag & 7 || e.type === De;
function ac(e, t, o) {
  const { props: n, children: r, component: s } = e, { props: i, children: c, patchFlag: f } = t, g = s.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (r || c) && Ye || t.dirs || t.transition)
    return !0;
  if (o && f >= 0) {
    if (f & 1024)
      return !0;
    if (f & 16)
      return n ? ur(n, i, g) : !!i;
    if (f & 8) {
      const h = t.dynamicProps;
      for (let d = 0; d < h.length; d++) {
        const v = h[d];
        if (i[v] !== n[v] && !Go(g, v))
          return !0;
      }
    }
  } else
    return (r || c) && (!c || !c.$stable) ? !0 : n === i ? !1 : n ? i ? ur(n, i, g) : !0 : !!i;
  return !1;
}
function ur(e, t, o) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < n.length; r++) {
    const s = n[r];
    if (t[s] !== e[s] && !Go(o, s))
      return !0;
  }
  return !1;
}
function uc({ vnode: e, parent: t }, o) {
  for (; t; ) {
    const n = t.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.el = e.el), n === e)
      (e = t.vnode).el = o, t = t.parent;
    else
      break;
  }
}
const Rs = (e) => e.__isSuspense;
function fc(e, t) {
  t && t.pendingBranch ? T(e) ? t.effects.push(...e) : t.effects.push(e) : ss(e);
}
const ce = Symbol.for("v-fgt"), co = Symbol.for("v-txt"), De = Symbol.for("v-cmt"), xo = Symbol.for("v-stc"), Xt = [];
let ke = null;
function L(e = !1) {
  Xt.push(ke = e ? null : []);
}
function dc() {
  Xt.pop(), ke = Xt[Xt.length - 1] || null;
}
let oo = 1;
function fr(e, t = !1) {
  oo += e, e < 0 && ke && t && (ke.hasOnce = !0);
}
function js(e) {
  return e.dynamicChildren = oo > 0 ? ke || Pt : null, dc(), oo > 0 && ke && ke.push(e), e;
}
function K(e, t, o, n, r, s) {
  return js(
    I(
      e,
      t,
      o,
      n,
      r,
      s,
      !0
    )
  );
}
function yn(e, t, o, n, r) {
  return js(
    Pe(
      e,
      t,
      o,
      n,
      r,
      !0
    )
  );
}
function ao(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Kt(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const o = yo.get(t.type);
    if (o && o.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const pc = (...e) => zs(
  ...e
), Fs = ({ key: e }) => e ?? null, No = ({
  ref: e,
  ref_key: t,
  ref_for: o
}) => (typeof e == "number" && (e = "" + e), e != null ? Z(e) || ie(e) || k(e) ? { i: pe, r: e, k: t, f: !!o } : e : null);
function I(e, t = null, o = null, n = 0, r = null, s = e === ce ? 0 : 1, i = !1, c = !1) {
  const f = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Fs(t),
    ref: t && No(t),
    scopeId: fs,
    slotScopeIds: null,
    children: o,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: s,
    patchFlag: n,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: pe
  };
  return c ? (Ln(f, o), s & 128 && e.normalize(f)) : o && (f.shapeFlag |= Z(o) ? 8 : 16), process.env.NODE_ENV !== "production" && f.key !== f.key && N("VNode created with invalid key (NaN). VNode type:", f.type), oo > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  ke && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (f.patchFlag > 0 || s & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  f.patchFlag !== 32 && ke.push(f), f;
}
const Pe = process.env.NODE_ENV !== "production" ? pc : zs;
function zs(e, t = null, o = null, n = 0, r = null, s = !1) {
  if ((!e || e === Ol) && (process.env.NODE_ENV !== "production" && !e && N(`Invalid vnode type when creating vnode: ${e}.`), e = De), ao(e)) {
    const c = gt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return o && Ln(c, o), oo > 0 && !s && ke && (c.shapeFlag & 6 ? ke[ke.indexOf(e)] = c : ke.push(c)), c.patchFlag = -2, c;
  }
  if (Ks(e) && (e = e.__vccOpts), t) {
    t = hc(t);
    let { class: c, style: f } = t;
    c && !Z(c) && (t.class = $t(c)), J(f) && (So(f) && !T(f) && (f = ee({}, f)), t.style = se(f));
  }
  const i = Z(e) ? 1 : Rs(e) ? 128 : fl(e) ? 64 : J(e) ? 4 : k(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && i & 4 && So(e) && (e = M(e), N(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), I(
    e,
    t,
    o,
    n,
    r,
    i,
    s,
    !0
  );
}
function hc(e) {
  return e ? So(e) || Os(e) ? ee({}, e) : e : null;
}
function gt(e, t, o = !1, n = !1) {
  const { props: r, ref: s, patchFlag: i, children: c, transition: f } = e, g = t ? gc(r || {}, t) : r, h = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: g,
    key: g && Fs(g),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      o && s ? T(s) ? s.concat(No(t)) : [s, No(t)] : No(t)
    ) : s,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && T(c) ? c.map(Hs) : c,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== ce ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: f,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && gt(e.ssContent),
    ssFallback: e.ssFallback && gt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return f && n && Mn(
    h,
    f.clone(h)
  ), h;
}
function Hs(e) {
  const t = gt(e);
  return T(e.children) && (t.children = e.children.map(Hs)), t;
}
function Ls(e = " ", t = 0) {
  return Pe(co, null, e, t);
}
function de(e = "", t = !1) {
  return t ? (L(), yn(De, null, e)) : Pe(De, null, e);
}
function Re(e) {
  return e == null || typeof e == "boolean" ? Pe(De) : T(e) ? Pe(
    ce,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : ao(e) ? ft(e) : Pe(co, null, String(e));
}
function ft(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : gt(e);
}
function Ln(e, t) {
  let o = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (T(t))
    o = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), Ln(e, r()), r._c && (r._d = !0));
      return;
    } else {
      o = 32;
      const r = t._;
      !r && !Os(t) ? t._ctx = pe : r === 3 && pe && (pe.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else k(t) ? (t = { default: t, _ctx: pe }, o = 32) : (t = String(t), n & 64 ? (o = 16, t = [Ls(t)]) : o = 8);
  e.children = t, e.shapeFlag |= o;
}
function gc(...e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const n = e[o];
    for (const r in n)
      if (r === "class")
        t.class !== n.class && (t.class = $t([t.class, n.class]));
      else if (r === "style")
        t.style = se([t.style, n.style]);
      else if (ro(r)) {
        const s = t[r], i = n[r];
        i && s !== i && !(T(s) && s.includes(i)) && (t[r] = s ? [].concat(s, i) : i);
      } else r !== "" && (t[r] = n[r]);
  }
  return t;
}
function Ke(e, t, o, n = null) {
  Xe(e, t, 7, [
    o,
    n
  ]);
}
const mc = ws();
let bc = 0;
function vc(e, t, o) {
  const n = e.type, r = (t ? t.appContext : e.appContext) || mc, s = {
    uid: bc++,
    vnode: e,
    type: n,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new mi(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Vs(n, r),
    emitsOptions: $s(n, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: q,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: q,
    data: q,
    props: q,
    attrs: q,
    slots: q,
    refs: q,
    setupState: q,
    setupContext: null,
    // suspense related
    suspense: o,
    suspenseId: o ? o.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? s.ctx = Vl(s) : s.ctx = { _: s }, s.root = t ? t.root : s, s.emit = ic.bind(null, s), e.ce && e.ce(s), s;
}
let ue = null;
const _c = () => ue || pe;
let Ro, wn;
{
  const e = so(), t = (o, n) => {
    let r;
    return (r = e[o]) || (r = e[o] = []), r.push(n), (s) => {
      r.length > 1 ? r.forEach((i) => i(s)) : r[0](s);
    };
  };
  Ro = t(
    "__VUE_INSTANCE_SETTERS__",
    (o) => ue = o
  ), wn = t(
    "__VUE_SSR_SETTERS__",
    (o) => no = o
  );
}
const uo = (e) => {
  const t = ue;
  return Ro(e), e.scope.on(), () => {
    e.scope.off(), Ro(t);
  };
}, dr = () => {
  ue && ue.scope.off(), Ro(null);
}, yc = /* @__PURE__ */ nt("slot,component");
function En(e, { isNativeTag: t }) {
  (yc(e) || t(e)) && N(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Bs(e) {
  return e.vnode.shapeFlag & 4;
}
let no = !1;
function wc(e, t = !1, o = !1) {
  t && wn(t);
  const { props: n, children: r } = e.vnode, s = Bs(e);
  jl(e, n, s, t), Jl(e, r, o);
  const i = s ? Ec(e, t) : void 0;
  return t && wn(!1), i;
}
function Ec(e, t) {
  var o;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && En(n.name, e.appContext.config), n.components) {
      const s = Object.keys(n.components);
      for (let i = 0; i < s.length; i++)
        En(s[i], e.appContext.config);
    }
    if (n.directives) {
      const s = Object.keys(n.directives);
      for (let i = 0; i < s.length; i++)
        ps(s[i]);
    }
    n.compilerOptions && xc() && N(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, vs), process.env.NODE_ENV !== "production" && Sl(e);
  const { setup: r } = n;
  if (r) {
    st();
    const s = e.setupContext = r.length > 1 ? Oc(e) : null, i = uo(e), c = Ft(
      r,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Je(e.props) : e.props,
        s
      ]
    ), f = On(c);
    if (it(), i(), (f || e.sp) && !Rt(e) && hs(e), f) {
      if (c.then(dr, dr), t)
        return c.then((g) => {
          pr(e, g, t);
        }).catch((g) => {
          io(g, e, 0);
        });
      if (e.asyncDep = c, process.env.NODE_ENV !== "production" && !e.suspense) {
        const g = (o = n.name) != null ? o : "Anonymous";
        N(
          `Component <${g}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      pr(e, c, t);
  } else
    Us(e, t);
}
function pr(e, t, o) {
  k(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : J(t) ? (process.env.NODE_ENV !== "production" && ao(t) && N(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = es(t), process.env.NODE_ENV !== "production" && Cl(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && N(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), Us(e, o);
}
const xc = () => !0;
function Us(e, t, o) {
  const n = e.type;
  e.render || (e.render = n.render || ae);
  {
    const r = uo(e);
    st();
    try {
      Al(e);
    } finally {
      it(), r();
    }
  }
  process.env.NODE_ENV !== "production" && !n.render && e.render === ae && !t && (n.template ? N(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : N("Component is missing template or render function: ", n));
}
const hr = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Mo(), le(e, "get", ""), e[t];
  },
  set() {
    return N("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return N("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return le(e, "get", ""), e[t];
  }
};
function Nc(e) {
  return new Proxy(e.slots, {
    get(t, o) {
      return le(e, "get", "$slots"), t[o];
    }
  });
}
function Oc(e) {
  const t = (o) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && N("expose() should be called only once per setup()."), o != null)) {
      let n = typeof o;
      n === "object" && (T(o) ? n = "array" : ie(o) && (n = "ref")), n !== "object" && N(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = o || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let o, n;
    return Object.freeze({
      get attrs() {
        return o || (o = new Proxy(e.attrs, hr));
      },
      get slots() {
        return n || (n = Nc(e));
      },
      get emit() {
        return (r, ...s) => e.emit(r, ...s);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, hr),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function Bn(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(es(Ri(e.exposed)), {
    get(t, o) {
      if (o in t)
        return t[o];
      if (o in Dt)
        return Dt[o](e);
    },
    has(t, o) {
      return o in t || o in Dt;
    }
  })) : e.proxy;
}
const Dc = /(?:^|[-_])(\w)/g, Vc = (e) => e.replace(Dc, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Ws(e, t = !0) {
  return k(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Jo(e, t, o = !1) {
  let n = Ws(t);
  if (!n && t.__file) {
    const r = t.__file.match(/([^/\\]+)\.\w+$/);
    r && (n = r[1]);
  }
  if (!n && e && e.parent) {
    const r = (s) => {
      for (const i in s)
        if (s[i] === t)
          return i;
    };
    n = r(
      e.components || e.parent.type.components
    ) || r(e.appContext.components);
  }
  return n ? Vc(n) : o ? "App" : "Anonymous";
}
function Ks(e) {
  return k(e) && "__vccOpts" in e;
}
const te = (e, t) => {
  const o = Li(e, t, no);
  if (process.env.NODE_ENV !== "production") {
    const n = _c();
    n && n.appContext.config.warnRecursiveComputed && (o._warnRecursive = !0);
  }
  return o;
};
function Sc() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, o = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(d) {
      return J(d) ? d.__isVue ? ["div", e, "VueInstance"] : ie(d) ? [
        "div",
        {},
        ["span", e, h(d)],
        "<",
        // avoid debugger accessing value affecting behavior
        c("_value" in d ? d._value : d),
        ">"
      ] : Nt(d) ? [
        "div",
        {},
        ["span", e, we(d) ? "ShallowReactive" : "Reactive"],
        "<",
        c(d),
        `>${ot(d) ? " (readonly)" : ""}`
      ] : ot(d) ? [
        "div",
        {},
        ["span", e, we(d) ? "ShallowReadonly" : "Readonly"],
        "<",
        c(d),
        ">"
      ] : null : null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...s(d.$)
        ];
    }
  };
  function s(d) {
    const v = [];
    d.type.props && d.props && v.push(i("props", M(d.props))), d.setupState !== q && v.push(i("setup", d.setupState)), d.data !== q && v.push(i("data", M(d.data)));
    const x = f(d, "computed");
    x && v.push(i("computed", x));
    const C = f(d, "inject");
    return C && v.push(i("injected", C)), v.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), v;
  }
  function i(d, v) {
    return v = ee({}, v), Object.keys(v).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(v).map((x) => [
          "div",
          {},
          ["span", n, x + ": "],
          c(v[x], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function c(d, v = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", o, JSON.stringify(d)] : typeof d == "boolean" ? ["span", n, d] : J(d) ? ["object", { object: v ? M(d) : d }] : ["span", o, String(d)];
  }
  function f(d, v) {
    const x = d.type;
    if (k(x))
      return;
    const C = {};
    for (const $ in d.ctx)
      g(x, $, v) && (C[$] = d.ctx[$]);
    return C;
  }
  function g(d, v, x) {
    const C = d[x];
    if (T(C) && C.includes(v) || J(C) && v in C || d.extends && g(d.extends, v, x) || d.mixins && d.mixins.some(($) => g($, v, x)))
      return !0;
  }
  function h(d) {
    return we(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
const gr = "3.5.13", $e = process.env.NODE_ENV !== "production" ? N : ae;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let xn;
const mr = typeof window < "u" && window.trustedTypes;
if (mr)
  try {
    xn = /* @__PURE__ */ mr.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && $e(`Error creating trusted types policy: ${e}`);
  }
const qs = xn ? (e) => xn.createHTML(e) : (e) => e, Cc = "http://www.w3.org/2000/svg", Tc = "http://www.w3.org/1998/Math/MathML", tt = typeof document < "u" ? document : null, br = tt && /* @__PURE__ */ tt.createElement("template"), Ac = {
  insert: (e, t, o) => {
    t.insertBefore(e, o || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, o, n) => {
    const r = t === "svg" ? tt.createElementNS(Cc, e) : t === "mathml" ? tt.createElementNS(Tc, e) : o ? tt.createElement(e, { is: o }) : tt.createElement(e);
    return e === "select" && n && n.multiple != null && r.setAttribute("multiple", n.multiple), r;
  },
  createText: (e) => tt.createTextNode(e),
  createComment: (e) => tt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => tt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, o, n, r, s) {
    const i = o ? o.previousSibling : t.lastChild;
    if (r && (r === s || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), o), !(r === s || !(r = r.nextSibling)); )
        ;
    else {
      br.innerHTML = qs(
        n === "svg" ? `<svg>${e}</svg>` : n === "mathml" ? `<math>${e}</math>` : e
      );
      const c = br.content;
      if (n === "svg" || n === "mathml") {
        const f = c.firstChild;
        for (; f.firstChild; )
          c.appendChild(f.firstChild);
        c.removeChild(f);
      }
      t.insertBefore(c, o);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      o ? o.previousSibling : t.lastChild
    ];
  }
}, Ic = Symbol("_vtc");
function kc(e, t, o) {
  const n = e[Ic];
  n && (t = (t ? [t, ...n] : [...n]).join(" ")), t == null ? e.removeAttribute("class") : o ? e.setAttribute("class", t) : e.className = t;
}
const vr = Symbol("_vod"), Pc = Symbol("_vsh");
process.env.NODE_ENV;
const $c = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), Mc = /(^|;)\s*display\s*:/;
function Rc(e, t, o) {
  const n = e.style, r = Z(o);
  let s = !1;
  if (o && !r) {
    if (t)
      if (Z(t))
        for (const i of t.split(";")) {
          const c = i.slice(0, i.indexOf(":")).trim();
          o[c] == null && Oo(n, c, "");
        }
      else
        for (const i in t)
          o[i] == null && Oo(n, i, "");
    for (const i in o)
      i === "display" && (s = !0), Oo(n, i, o[i]);
  } else if (r) {
    if (t !== o) {
      const i = n[$c];
      i && (o += ";" + i), n.cssText = o, s = Mc.test(o);
    }
  } else t && e.removeAttribute("style");
  vr in e && (e[vr] = s ? n.display : "", e[Pc] && (n.display = "none"));
}
const jc = /[^\\];\s*$/, _r = /\s*!important$/;
function Oo(e, t, o) {
  if (T(o))
    o.forEach((n) => Oo(e, t, n));
  else if (o == null && (o = ""), process.env.NODE_ENV !== "production" && jc.test(o) && $e(
    `Unexpected semicolon at the end of '${t}' style value: '${o}'`
  ), t.startsWith("--"))
    e.setProperty(t, o);
  else {
    const n = Fc(e, t);
    _r.test(o) ? e.setProperty(
      Ie(n),
      o.replace(_r, ""),
      "important"
    ) : e[n] = o;
  }
}
const yr = ["Webkit", "Moz", "ms"], sn = {};
function Fc(e, t) {
  const o = sn[t];
  if (o)
    return o;
  let n = Oe(t);
  if (n !== "filter" && n in e)
    return sn[t] = n;
  n = Ho(n);
  for (let r = 0; r < yr.length; r++) {
    const s = yr[r] + n;
    if (s in e)
      return sn[t] = s;
  }
  return t;
}
const wr = "http://www.w3.org/1999/xlink";
function Er(e, t, o, n, r, s = gi(t)) {
  n && t.startsWith("xlink:") ? o == null ? e.removeAttributeNS(wr, t.slice(6, t.length)) : e.setAttributeNS(wr, t, o) : o == null || s && !kr(o) ? e.removeAttribute(t) : e.setAttribute(
    t,
    s ? "" : rt(o) ? String(o) : o
  );
}
function xr(e, t, o, n, r) {
  if (t === "innerHTML" || t === "textContent") {
    o != null && (e[t] = t === "innerHTML" ? qs(o) : o);
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    const c = s === "OPTION" ? e.getAttribute("value") || "" : e.value, f = o == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(o);
    (c !== f || !("_value" in e)) && (e.value = f), o == null && e.removeAttribute(t), e._value = o;
    return;
  }
  let i = !1;
  if (o === "" || o == null) {
    const c = typeof e[t];
    c === "boolean" ? o = kr(o) : o == null && c === "string" ? (o = "", i = !0) : c === "number" && (o = 0, i = !0);
  }
  try {
    e[t] = o;
  } catch (c) {
    process.env.NODE_ENV !== "production" && !i && $e(
      `Failed setting prop "${t}" on <${s.toLowerCase()}>: value ${o} is invalid.`,
      c
    );
  }
  i && e.removeAttribute(r || t);
}
function zc(e, t, o, n) {
  e.addEventListener(t, o, n);
}
function Hc(e, t, o, n) {
  e.removeEventListener(t, o, n);
}
const Nr = Symbol("_vei");
function Lc(e, t, o, n, r = null) {
  const s = e[Nr] || (e[Nr] = {}), i = s[t];
  if (n && i)
    i.value = process.env.NODE_ENV !== "production" ? Dr(n, t) : n;
  else {
    const [c, f] = Bc(t);
    if (n) {
      const g = s[t] = Kc(
        process.env.NODE_ENV !== "production" ? Dr(n, t) : n,
        r
      );
      zc(e, c, g, f);
    } else i && (Hc(e, c, i, f), s[t] = void 0);
  }
}
const Or = /(?:Once|Passive|Capture)$/;
function Bc(e) {
  let t;
  if (Or.test(e)) {
    t = {};
    let n;
    for (; n = e.match(Or); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Ie(e.slice(2)), t];
}
let ln = 0;
const Uc = /* @__PURE__ */ Promise.resolve(), Wc = () => ln || (Uc.then(() => ln = 0), ln = Date.now());
function Kc(e, t) {
  const o = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= o.attached)
      return;
    Xe(
      qc(n, o.value),
      t,
      5,
      [n]
    );
  };
  return o.value = e, o.attached = Wc(), o;
}
function Dr(e, t) {
  return k(e) || T(e) ? e : ($e(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), ae);
}
function qc(e, t) {
  if (T(t)) {
    const o = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      o.call(e), e._stopped = !0;
    }, t.map(
      (n) => (r) => !r._stopped && n && n(r)
    );
  } else
    return t;
}
const Vr = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Gc = (e, t, o, n, r, s) => {
  const i = r === "svg";
  t === "class" ? kc(e, n, i) : t === "style" ? Rc(e, o, n) : ro(t) ? Do(t) || Lc(e, t, o, n, s) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Jc(e, t, n, i)) ? (xr(e, t, n), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Er(e, t, n, i, s, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Z(n)) ? xr(e, Oe(t), n, s, t) : (t === "true-value" ? e._trueValue = n : t === "false-value" && (e._falseValue = n), Er(e, t, n, i));
};
function Jc(e, t, o, n) {
  if (n)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Vr(t) && k(o));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return Vr(t) && Z(o) ? !1 : t in e;
}
const Sr = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Yc(e, t, o) {
  const n = /* @__PURE__ */ dl(e, t);
  Fo(n) && ee(n, t);
  class r extends Un {
    constructor(i) {
      super(n, i, o);
    }
  }
  return r.def = n, r;
}
const Qc = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Un extends Qc {
  constructor(t, o = {}, n = Tr) {
    super(), this._def = t, this._props = o, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && n !== Tr ? this._root = this.shadowRoot : (process.env.NODE_ENV !== "production" && this.shadowRoot && $e(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this), this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof Un) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, ns(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let n = 0; n < this.attributes.length; n++)
      this._setAttr(this.attributes[n].name);
    this._ob = new MutationObserver((n) => {
      for (const r of n)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (n, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: s, styles: i } = n;
      let c;
      if (s && !T(s))
        for (const f in s) {
          const g = s[f];
          (g === Number || g && g.type === Number) && (f in this._props && (this._props[f] = qn(this._props[f])), (c || (c = /* @__PURE__ */ Object.create(null)))[Oe(f)] = !0);
        }
      this._numberProps = c, r && this._resolveProps(n), this.shadowRoot ? this._applyStyles(i) : process.env.NODE_ENV !== "production" && i && $e(
        "Custom element style injection is not supported when using shadowRoot: false"
      ), this._mount(n);
    }, o = this._def.__asyncLoader;
    o ? this._pendingResolve = o().then(
      (n) => t(this._def = n, !0)
    ) : t(this._def);
  }
  _mount(t) {
    process.env.NODE_ENV !== "production" && !t.name && (t.name = "VueElement"), this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const o = this._instance && this._instance.exposed;
    if (o)
      for (const n in o)
        H(this, n) ? process.env.NODE_ENV !== "production" && $e(`Exposed property "${n}" already exists on custom element.`) : Object.defineProperty(this, n, {
          // unwrap ref to be consistent with public instance behavior
          get: () => Zr(o[n])
        });
  }
  _resolveProps(t) {
    const { props: o } = t, n = T(o) ? o : Object.keys(o || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && n.includes(r) && this._setProp(r, this[r]);
    for (const r of n.map(Oe))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(s) {
          this._setProp(r, s, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const o = this.hasAttribute(t);
    let n = o ? this.getAttribute(t) : Sr;
    const r = Oe(t);
    o && this._numberProps && this._numberProps[r] && (n = qn(n)), this._setProp(r, n, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, o, n = !0, r = !1) {
    if (o !== this._props[t] && (o === Sr ? delete this._props[t] : (this._props[t] = o, t === "key" && this._app && (this._app._ceVNode.key = o)), r && this._instance && this._update(), n)) {
      const s = this._ob;
      s && s.disconnect(), o === !0 ? this.setAttribute(Ie(t), "") : typeof o == "string" || typeof o == "number" ? this.setAttribute(Ie(t), o + "") : o || this.removeAttribute(Ie(t)), s && s.observe(this, { attributes: !0 });
    }
  }
  _update() {
    Zc(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const o = Pe(this._def, ee(t, this._props));
    return this._instance || (o.ce = (n) => {
      this._instance = n, n.ce = this, n.isCE = !0, process.env.NODE_ENV !== "production" && (n.ceReload = (s) => {
        this._styles && (this._styles.forEach((i) => this._root.removeChild(i)), this._styles.length = 0), this._applyStyles(s), this._instance = null, this._update();
      });
      const r = (s, i) => {
        this.dispatchEvent(
          new CustomEvent(
            s,
            Fo(i[0]) ? ee({ detail: i }, i[0]) : { detail: i }
          )
        );
      };
      n.emit = (s, ...i) => {
        r(s, i), Ie(s) !== s && r(Ie(s), i);
      }, this._setParent();
    }), o;
  }
  _applyStyles(t, o) {
    if (!t) return;
    if (o) {
      if (o === this._def || this._styleChildren.has(o))
        return;
      this._styleChildren.add(o);
    }
    const n = this._nonce;
    for (let r = t.length - 1; r >= 0; r--) {
      const s = document.createElement("style");
      if (n && s.setAttribute("nonce", n), s.textContent = t[r], this.shadowRoot.prepend(s), process.env.NODE_ENV !== "production")
        if (o) {
          if (o.__hmrId) {
            this._childStyles || (this._childStyles = /* @__PURE__ */ new Map());
            let i = this._childStyles.get(o.__hmrId);
            i || this._childStyles.set(o.__hmrId, i = []), i.push(s);
          }
        } else
          (this._styles || (this._styles = [])).push(s);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let o;
    for (; o = this.firstChild; ) {
      const n = o.nodeType === 1 && o.getAttribute("slot") || "default";
      (t[n] || (t[n] = [])).push(o), this.removeChild(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), o = this._instance.type.__scopeId;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], s = r.getAttribute("name") || "default", i = this._slots[s], c = r.parentNode;
      if (i)
        for (const f of i) {
          if (o && f.nodeType === 1) {
            const g = o + "-s", h = document.createTreeWalker(f, 1);
            f.setAttribute(g, "");
            let d;
            for (; d = h.nextNode(); )
              d.setAttribute(g, "");
          }
          c.insertBefore(f, r);
        }
      else
        for (; r.firstChild; ) c.insertBefore(r.firstChild, r);
      c.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
    if (process.env.NODE_ENV !== "production" && (this._styleChildren.delete(t), this._childStyles && t.__hmrId)) {
      const o = this._childStyles.get(t.__hmrId);
      o && (o.forEach((n) => this._root.removeChild(n)), o.length = 0);
    }
  }
}
const Xc = /* @__PURE__ */ ee({ patchProp: Gc }, Ac);
let Cr;
function Gs() {
  return Cr || (Cr = Xl(Xc));
}
const Zc = (...e) => {
  Gs().render(...e);
}, Tr = (...e) => {
  const t = Gs().createApp(...e);
  process.env.NODE_ENV !== "production" && (ta(t), oa(t));
  const { mount: o } = t;
  return t.mount = (n) => {
    const r = na(n);
    if (!r) return;
    const s = t._component;
    !k(s) && !s.render && !s.template && (s.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const i = o(r, !1, ea(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), i;
  }, t;
};
function ea(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function ta(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => fi(t) || di(t) || pi(t),
    writable: !1
  });
}
function oa(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        $e(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const o = e.config.compilerOptions, n = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return $e(n), o;
      },
      set() {
        $e(n);
      }
    });
  }
}
function na(e) {
  if (Z(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && $e(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && $e(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ra() {
  Sc();
}
process.env.NODE_ENV !== "production" && ra();
const sa = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, r] of t)
    o[n] = r;
  return o;
};
function Js(e) {
  let t = 0, o = 0, n = 0;
  return e.length === 4 ? (t = parseInt(e[1] + e[1], 16), o = parseInt(e[2] + e[2], 16), n = parseInt(e[3] + e[3], 16)) : e.length === 7 && (t = parseInt(e.substring(1, 3), 16), o = parseInt(e.substring(3, 5), 16), n = parseInt(e.substring(5, 7), 16)), { r: t, g: o, b: n };
}
function Ys(e) {
  const t = e.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/) || e.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
  return t ? {
    r: parseInt(t[1]),
    g: parseInt(t[2]),
    b: parseInt(t[3])
  } : null;
}
function Qs(e) {
  let t, o, n;
  if (e.startsWith("#")) {
    const s = Js(e);
    t = s.r, o = s.g, n = s.b;
  } else if (e.startsWith("rgb")) {
    const s = Ys(e);
    if (s)
      t = s.r, o = s.g, n = s.b;
    else
      return "white";
  } else
    return "white";
  return (0.299 * t + 0.587 * o + 0.114 * n) / 255 > 0.5 ? "black" : "white";
}
function ia(e, t) {
  let o, n, r;
  if (e.startsWith("#")) {
    const i = Js(e);
    o = i.r, n = i.g, r = i.b;
  } else if (e.startsWith("rgb")) {
    const i = Ys(e);
    if (i)
      o = i.r, n = i.g, r = i.b;
    else
      return e;
  } else
    return e;
  const s = 1 + t;
  return o = Math.min(255, Math.floor(o * s)), n = Math.min(255, Math.floor(n * s)), r = Math.min(255, Math.floor(r * s)), `rgb(${o}, ${n}, ${r})`;
}
const la = {
  key: 0,
  class: "fixed inset-0 z-[999] flex items-center justify-center"
}, ca = { class: "bg-white p-6 rounded-lg shadow-xl relative max-w-md mx-auto" }, aa = { class: "text-xl font-bold mb-4 text-gray-800" }, ua = { class: "text-gray-700 mb-6" }, fa = { class: "flex justify-end" }, da = {
  __name: "InfoPopup",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "Information"
    },
    message: {
      type: String,
      default: ""
    },
    primaryColor: {
      // New prop for primary button color
      type: String,
      default: "#FFFFFF"
      // Default to the existing primary color from your palette
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = e, n = t, r = te(() => Qs(o.primaryColor));
    function s() {
      n("update:modelValue", !1);
    }
    return Vt(() => o.modelValue, (i) => {
      console.log("InfoPopup: modelValue changed to:", i);
    }), console.log("InfoPopup component setup. Initial modelValue:", o.modelValue), (i, c) => e.modelValue ? (L(), K("div", la, [
      I("div", {
        class: "absolute inset-0 bg-black opacity-50",
        onClick: s
      }),
      I("div", ca, [
        I("h3", aa, oe(e.title), 1),
        I("p", ua, oe(e.message), 1),
        I("div", fa, [
          I("button", {
            onClick: s,
            style: se({ backgroundColor: e.primaryColor, color: r.value }),
            class: "px-4 py-2 bg-indigo-600 text-white rounded-lg"
          }, " OK ", 4)
        ])
      ])
    ])) : de("", !0);
  }
}, pa = {
  __name: "MyPortal",
  setup(e) {
    return (t, o) => Dl(t.$slots, "default");
  }
};
function ha(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return console.log("error in cloneMe: " + t.message), console.trace(), e;
  }
}
const ga = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.right-4{right:1rem}.top-4{top:1rem}.z-\\[90\\]{z-index:90}.z-\\[999\\]{z-index:999}.mx-auto{margin-left:auto;margin-right:auto}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-5{margin-bottom:1.25rem}.mb-6{margin-bottom:1.5rem}.ml-10{margin-left:2.5rem}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.flex{display:flex}.grid{display:grid}.hidden{display:none}.h-10{height:2.5rem}.h-2\\.5{height:.625rem}.h-6{height:1.5rem}.w-10{width:2.5rem}.w-6{width:1.5rem}.w-full{width:100%}.max-w-md{max-width:28rem}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.cursor-pointer{cursor:pointer}.resize{resize:both}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-3{gap:.75rem}.gap-6{gap:1.5rem}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.rounded-2xl{border-radius:1rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-xl{border-radius:.75rem}.border{border-width:1px}.border-t{border-top-width:1px}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}.border-gray-400{--tw-border-opacity: 1;border-color:rgb(156 163 175 / var(--tw-border-opacity, 1))}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity, 1))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229 231 235 / var(--tw-bg-opacity, 1))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.bg-indigo-600{--tw-bg-opacity: 1;background-color:rgb(79 70 229 / var(--tw-bg-opacity, 1))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.object-cover{-o-object-fit:cover;object-fit:cover}.p-4{padding:1rem}.p-6{padding:1.5rem}.p-8{padding:2rem}.px-4{padding-left:1rem;padding-right:1rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-8{padding-left:2rem;padding-right:2rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-0{padding-bottom:0}.pb-6{padding-bottom:1.5rem}.pt-0{padding-top:0}.text-left{text-align:left}.text-center{text-align:center}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.text-gray-500{--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.text-gray-800{--tw-text-opacity: 1;color:rgb(31 41 55 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.opacity-50{opacity:.5}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.item-grid-bottom{z-index:3}.maxHeightDescription{max-height:100px;overflow:hidden}.stepTitle{font-size:1.5em;line-height:1.3}.item-additionals-textSize{font-size:1.2em;line-height:1.25}.optionImage{width:122px;height:122px}.layout-grid{min-height:100px;min-width:75vw;width:calc(100% - 50px);max-height:94vh;overflow:hidden;display:grid;grid-template-rows:auto minmax(0,1fr) min-content;margin:0 25px}.item-additionals{max-height:100%}.item-additionals .description{color:#4b5563}.quantity-button{display:flex;height:2.5rem;width:2.5rem;align-items:center;justify-content:center;border-radius:9999px;font-size:1.25rem;line-height:1.75rem;font-weight:700;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);background-color:#e2e8f0;color:#475569;box-shadow:0 2px 4px #0000000d}.quantity-button:hover{background-color:#cbd5e1}.quantity-button.increment:hover{filter:brightness(.85)}.add-to-cart-button{border-radius:9999px;padding:.75rem 2rem;font-weight:700;--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);font-size:1.2em;line-height:1.25}.add-to-cart-button:hover{filter:brightness(.85)}.add-to-cart-button:disabled{cursor:not-allowed}.add-to-cart-button:disabled:hover{filter:none}.accordion-item{background-color:#fff}.options-grid{item-grid-template-columns:repeat(auto-fill,minmax(200px,1fr))}.hover\\:bg-gray-100:hover{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-primary:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(158 127 255 / var(--tw-ring-opacity, 1))}.focus\\:ring-opacity-50:focus{--tw-ring-opacity: .5}@media (min-width: 640px){.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (min-width: 768px){.md\\:w-2\\/5{width:40%}.md\\:flex-row{flex-direction:row}}@media (min-width: 1024px){.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}', ma = { class: "layout-grid bg-white rounded-2xl shadow-md relative" }, ba = { class: "item-grid-top" }, va = { class: "relative p-8 pb-0" }, _a = { class: "flex flex-col md:flex-row items-start gap-6 mb-6" }, ya = {
  key: 0,
  class: "flex-shrink-0 w-full md:w-2/5"
}, wa = ["src", "alt"], Ea = { class: "flex-grow" }, xa = { class: "text-3xl font-bold text-gray-800" }, Na = ["innerHTML"], Oa = {
  key: 0,
  class: "text-sm text-gray-500 mt-2"
}, Da = {
  key: 0,
  class: "size-selection mt-6"
}, Va = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3" }, Sa = ["onClick"], Ca = { class: "item-grid-middle p-8 pb-0 pt-0" }, Ta = {
  key: 0,
  class: "progress-indicator text-center mb-6"
}, Aa = { class: "text-lg font-semibold text-gray-700" }, Ia = { class: "w-full bg-gray-200 rounded-full h-2.5 mt-2" }, ka = { class: "item-additionals scrollable-area overflow-y-auto w-full mx-auto relative pb-6" }, Pa = {
  key: 0,
  class: "replace-article-variants-section mt-3"
}, $a = { class: "stepTitle font-semibold text-gray-700 mb-5" }, Ma = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6" }, Ra = ["onClick"], ja = ["src", "alt"], Fa = { class: "w-full" }, za = {
  key: 1,
  class: "variants-accordion space-y-6"
}, Ha = { class: "accordion-item border border-gray-400 rounded-lg overflow-hidden" }, La = { class: "accordion-header w-full flex justify-between items-center p-4 stepTitle font-semibold text-left text-gray-700 bg-gray-50 hover:bg-gray-100 transition-colors duration-200" }, Ba = { class: "flex flex-col" }, Ua = {
  key: 0,
  class: "text-sm font-normal text-gray-500 mt-1"
}, Wa = { class: "accordion-content p-4" }, Ka = { class: "options-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" }, qa = ["onClick"], Ga = ["src", "alt"], Ja = { class: "w-full" }, Ya = { key: 1 }, Qa = { class: "item-grid-bottom" }, Xa = { class: "add-to-cart-section px-8 py-4 border-t border-gray-200 flex items-center justify-between" }, Za = { class: "flex items-center space-x-4" }, eu = { class: "text-2xl font-bold text-gray-800" }, tu = { class: "flex items-center space-x-4" }, ou = ["disabled"], nu = {
  __name: "WcApp",
  props: {
    article: {
      type: String,
      default: ""
    },
    items: {
      type: String,
      default: "[]"
    },
    title: {
      type: String,
      default: "title"
    },
    primaryColor: {
      // New prop for primary button color
      type: String,
      default: "#FFFFFF"
      // Default to the existing primary color from your palette
    },
    itemType: {
      type: String,
      default: "foodOrder"
    },
    // NEU: Übergabe der Währung von außen (z.B. 'EUR', 'USD', 'CHF')
    currency: {
      type: String,
      default: "EUR"
    },
    // NEU: Übergabe der Sprache/Region von außen (z.B. 'de-DE', 'en-US', 'de-CH')
    language: {
      type: String,
      default: "de-DE"
    }
  },
  emits: ["close-additionals", "click-image", "add-to-cart"],
  setup(e, { emit: t }) {
    const o = t, n = at(!1), r = at(""), s = at(""), i = (l, u, p) => {
      r.value = l, s.value = u, n.value = p;
    };
    Es("setPopup", i);
    const c = e, f = (l) => typeof l != "number" ? "" : new Intl.NumberFormat(c.language, {
      style: "currency",
      currency: c.currency
    }).format(l), g = Uo({}), h = at(1), d = at(null), v = at([]), x = (l) => !l || !Array.isArray(l.options) ? [] : l.options.filter((u) => u && typeof u == "object" && u.active !== !1), C = (l) => {
      console.log("initializeSelections...");
      for (const u in g)
        delete g[u];
      l && l.extras && l.extras.variants && l.extras.variants.forEach((u) => {
        const p = Array.isArray(u.options) ? u.options.filter((m) => m && typeof m == "object") : [];
        if (u.multi)
          g[u.title] = [];
        else {
          let m = null;
          !m && u.implicit && p.length > 0 && (m = p[0]), m ? g[u.title] = [m.id] : g[u.title] = [];
        }
      }), l && l.sizes && l.sizes.length > 0 ? d.value = l.sizes[0].vol : d.value = null;
    }, $ = at(window.innerHeight), ne = () => {
      $.value = window.innerHeight;
    };
    ms(() => {
      window.addEventListener("resize", ne);
    }), jn(() => {
      window.removeEventListener("resize", ne);
    });
    const U = te(() => $.value), X = te(() => U.value >= 1500);
    Vt(() => c.article, (l) => {
      if (l && typeof l == "string" && l.trim() !== "")
        try {
          const u = JSON.parse(l);
          console.log("articleData", u), C(u);
        } catch (u) {
          console.error("Failed to parse article JSON:", u);
        }
      else
        console.warn("Received empty or invalid article prop, skipping JSON parsing.");
    }, { immediate: !0 });
    const D = te(() => {
      try {
        return JSON.parse(c.article);
      } catch {
        return {
          nameDE: "Burger#1",
          descriptionDE: "direkt vom BBQ-Grill und echtem Raucharoma",
          posId: "3406",
          extras: {
            variants: [
              {
                title: "Hauptgericht ersetzen",
                options: [
                  {
                    id: "replace-opt-1",
                    posId: "R1",
                    labelDE: "Großer Salat",
                    cost: 12,
                    imageUrl: "https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  },
                  {
                    id: "replace-opt-2",
                    posId: "R2",
                    labelDE: "Veggie Bowl",
                    cost: 10.5,
                    imageUrl: "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !0,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Beispiel mit Implizit",
                options: [
                  {
                    id: "ia6vgda26kemhgg2fiu",
                    posId: "7347700000000002",
                    labelDE: "Pfand",
                    labelEN: "",
                    cost: 0.15,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !0
              },
              {
                title: "Min-Max Beispiel",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "aufvrlttbaamhgg9ihj",
                    posId: "4902",
                    labelDE: "Rinderstreifen",
                    cost: 6,
                    articleNo: ""
                  },
                  {
                    id: "e9p5jxa1bpvmhgg9ihj",
                    posId: "4903",
                    labelDE: "King Prawns",
                    cost: 7,
                    articleNo: ""
                  },
                  {
                    id: "5wdcmo5dgqsmhgg9ihj",
                    posId: "4904",
                    labelDE: "Hähnchenbrust",
                    cost: 5,
                    articleNo: ""
                  },
                  {
                    id: "6ksdkiit8tdmhgvdmb0",
                    posId: "89",
                    labelDE: "Portion Pommes Frites",
                    labelEN: "",
                    cost: 1.8,
                    articleNo: ""
                  },
                  {
                    id: "m3eset3ullmhgve1r8",
                    posId: "38",
                    labelDE: "Portion Kartoffelsalat mit Beilagen",
                    labelEN: "",
                    cost: 1.5,
                    articleNo: ""
                  }
                ],
                freeArticles: 2,
                maxOptions: 4,
                min: 1
              },
              {
                title: "Salatbeilage",
                options: [
                  {
                    id: "76s5mc4rsa5mhgg6c9s",
                    posId: "850f3d2b-69a4-4584-836e-f8f17a19d709",
                    labelDE: "Pommes Frites",
                    labelEN: "",
                    cost: 0,
                    articleNo: ""
                  },
                  {
                    id: "qnu73ht3p5mhgg6evk",
                    posId: "62b81be3-8565-469a-8755-51d05acc9c05",
                    labelDE: "Vollkornbrot",
                    labelEN: "",
                    cost: 1,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Dynamische bei Pommes",
                options: [
                  {
                    id: "sjjxuw9hm5mhgg7yue",
                    posId: "3e56f167-aa33-470c-8c36-653e23bc9128",
                    labelDE: "Ketchup",
                    labelEN: "",
                    cost: 0.2,
                    articleNo: ""
                  }
                ],
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                trigger: "76s5mc4rsa5mhgg6c9s"
              },
              {
                title: "Extras?",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "2lq3r4ugkavkprfevzy",
                    posId: "3410",
                    labelDE: "Extra Bacon",
                    cost: 1.5,
                    active: !1
                  },
                  {
                    id: "1od82o2vwfvkprfevzz",
                    posId: "3411",
                    labelDE: "Extra Käse",
                    cost: 1
                  }
                ]
              },
              {
                title: "Beilage",
                optional: !1,
                multi: !1,
                replaceArticle: !1,
                dropdown: !1,
                trigger: "2vu700ui35omkb9kkrq",
                implicit: !1,
                separateLineItem: !1
              }
            ]
          },
          substances: {
            aA: !0,
            aE: !0,
            lBIO: !0,
            aC: !0,
            z3: !0,
            z4: !0
          },
          gramm: 0,
          image: "https://file.qsignal.eu/demo1besttaste/images/foods/ajesh-tp-1633525.jpg",
          moreImages: [],
          validStores: [],
          streichPreis: 20.99,
          neu: !0,
          days: ["1", "2", "3", "4", "5", "6", "7"]
        };
      }
    }), he = te(() => {
      var l, u;
      return ((u = (l = D.value) == null ? void 0 : l.extras) == null ? void 0 : u.variants) || [];
    }), V = te(
      () => he.value.filter((l) => l.replaceArticle === !0)
    ), re = te(
      () => he.value.filter((l) => l.replaceArticle !== !0)
    ), fe = (l) => {
      if (!l.trigger)
        return !0;
      const u = l.trigger;
      for (const p in g)
        if ((g[p] || []).includes(u))
          return !0;
      return !1;
    }, G = te(() => {
      const l = [];
      return V.value.forEach((u) => {
        x(u).length > 0 && l.push({ ...u, type: "replace" });
      }), re.value.forEach((u) => {
        x(u).length > 0 && fe(u) && l.push({ ...u, type: "normal" });
      }), l;
    }), Q = at(0), F = te(() => G.value[Q.value]);
    Vt(Q, (l) => {
      v.value = [];
      const u = G.value[l];
      u && u.type === "normal" && v.value.push(u.title);
    }, { immediate: !0 });
    const Ve = {
      fPork: "Schweinefleisch",
      fBeef: "Rindfleisch",
      fOther: "Anderes Fleisch",
      aA: "Gluten",
      aB: "Krebstiere",
      aC: "Eier von Geflügel",
      aD: "Fisch",
      aE: "Erdnüsse",
      aF: "Sojabohnen",
      aG: "Milch und Milcherzeugnisse",
      aH: "Schalenfrüchte",
      aL: "Sellerie",
      aM: "Senf",
      aN: "Sesamen",
      aO: "Schwefeloxid und Sulfite",
      aP: "Lupinen",
      aR: "Weichtiere",
      z1: "Konservierungsstoff",
      z2: "Geschmacksverstärker",
      z3: "Antioxidationsmittel",
      z4: "Farbstoff",
      z5: "Phosphat",
      z6: "chininhaltig",
      z7: "koffeinhaltig",
      z8: "geschwefelt",
      z9: "Saccharin",
      z10: "Aspartam/ Phenylalaninquelle",
      z11: "Cyclamat",
      z12: "Acesulfam",
      z13: "geschwärzt",
      z14: "gewachst",
      z15: "gentechnisch"
    }, Ee = te(() => {
      if (!D.value || !D.value.substances)
        return "";
      const l = [];
      for (const u in D.value.substances)
        D.value.substances[u] && Ve[u] && l.push(Ve[u]);
      return l.join(", ");
    });
    te(() => {
      if (!D.value) return 0;
      const l = D.value.sizes && D.value.sizes.length > 0, u = V.value.length > 0;
      if (l && u) {
        let p = 1 / 0;
        return V.value.forEach((m) => {
          m.options.forEach((b) => {
            b && typeof b.cost == "number" && (p = Math.min(p, b.cost));
          });
        }), p === 1 / 0 ? 0 : p;
      } else {
        if (l)
          return Math.min(...D.value.sizes.map((p) => p.price));
        if (u) {
          let p = 1 / 0;
          return V.value.forEach((m) => {
            m.options.forEach((b) => {
              b && typeof b.cost == "number" && (p = Math.min(p, b.cost));
            });
          }), p === 1 / 0 ? 0 : p;
        }
      }
      return 0;
    }), te(() => D.value ? !!(D.value.sizes && D.value.sizes.length > 1 || V.value.length > 0) : !1);
    const mt = (l) => {
      if (!l)
        return "";
      const u = [];
      for (const p in l)
        l[p] && Ve[p] && u.push(Ve[p]);
      return u.join(", ");
    }, fo = () => {
      h.value++;
    }, ze = () => {
      h.value > 1 && h.value--;
    }, ge = (l) => {
      d.value = l;
    }, R = te(() => {
      let l = 0, u = !1;
      for (const m of V.value) {
        const b = g[m.title] || [];
        if (b.length > 0) {
          const E = b[0], _ = m.options.find((w) => w && w.id === E);
          if (_ && typeof _.cost == "number") {
            l = _.cost, u = !0;
            break;
          }
        }
      }
      if (!u && D.value && D.value.sizes && D.value.sizes.length > 0) {
        const m = D.value.sizes.find((b) => b.vol === d.value);
        l = m ? m.price : D.value.sizes[0].price;
      }
      let p = 0;
      return D.value && D.value.extras && D.value.extras.variants && D.value.extras.variants.forEach((m) => {
        if (m.replaceArticle !== !0) {
          const b = g[m.title] || [];
          if (b.length > 0) {
            const E = b.map((_) => m.options.find((w) => w && w.id === _)).filter((_) => _ && typeof _.cost == "number" && _.cost !== 0);
            if (m.multi && m.freeArticles && m.freeArticles > 0) {
              E.sort((_, w) => w.cost - _.cost);
              for (let _ = m.freeArticles; _ < E.length; _++)
                p += E[_].cost;
            } else
              E.forEach((_) => {
                p += _.cost;
              });
          }
        }
      }), (l + p) * h.value;
    }), j = te(() => {
      const l = F.value;
      return !l || l.type === "normal" && !fe(l) || l.optional || l.multi ? !0 : (g[l.title] || []).length > 0;
    }), xe = te(() => {
      if (!G.value.length)
        return !1;
      if (!Me.value)
        return !0;
      const l = F.value;
      if (!l)
        return console.log("isAddToCartButtonDisabled: No variant, returning true (disabled)"), !0;
      if (l.type === "normal" && !fe(l))
        return console.log(`isAddToCartButtonDisabled: Variant "${l.title}" is hidden, returning false (enabled)`), !1;
      const u = g[l.title] || [];
      if (l.min && l.min > 0) {
        const m = u.length < l.min;
        return console.log(`Rule 3 (min > 0): ${u.length} < ${l.min} -> Disabled: ${m}`), m;
      }
      if (l.multi || l.optional)
        return console.log("Rule 1 (multi=true) or Rule 2 (optional=true): Disabled: false"), !1;
      const p = u.length === 0;
      return console.log(`Rule 4 (!multi && !optional && !min): ${u.length} === 0 -> Disabled: ${p}`), p;
    }), Ct = te(() => Q.value === 0), Me = te(() => Q.value === G.value.length - 1 || !G.value.length), He = () => {
      if (!j.value) {
        i("Auswahl erforderlich", `Bitte wähle eine Option bei "${F.value.title}" aus, bevor du fortfährst.`, !0);
        return;
      }
      Me.value || Q.value++;
    }, Le = () => {
      Ct.value || Q.value--;
    }, zt = () => {
      if (console.log("addToCart function called!"), xe.value)
        return;
      for (const u of G.value)
        if (!(u.type === "normal" && !fe(u)))
          if (u.min && u.min > 0) {
            if ((g[u.title] || []).length < u.min) {
              i("Auswahl erforderlich", `Bitte wähle mindestens ${u.min} Option(en) bei "${u.title}" aus, bevor du den Artikel in den Korb legst.`, !0), Q.value = G.value.findIndex((m) => m.title === u.title);
              return;
            }
          } else {
            if (u.optional || u.multi)
              continue;
            if ((g[u.title] || []).length === 0) {
              i("Auswahl erforderlich", `Bitte wähle eine Option bei "${u.title}" aus, bevor du den Artikel in den Korb legst.`, !0), Q.value = G.value.findIndex((m) => m.title === u.title);
              return;
            }
          }
      const l = ha({
        article: D.value,
        selectedVariants: g,
        selectedSize: d.value,
        quantity: h.value,
        itemType: c.itemType,
        totalPrice: R.value
      });
      console.log("Adding to cart:", l), o("add-to-cart", JSON.stringify(l));
    }, Se = (l, u) => (g[l.title] || []).includes(u), po = (l, u) => {
      let p = g[l.title] || [];
      const m = l.implicit && !l.optional && x(l).length === 1;
      let b = !1;
      if (p.includes(u)) {
        if (m && p.length === 1) {
          i("Auswahl erforderlich", `Diese Option muss bei "${l.title}" ausgewählt bleiben.`, !0);
          return;
        }
        g[l.title] = p.filter((E) => E !== u);
      } else if (!l.multi)
        g[l.title] = [u], b = !0;
      else {
        if (l.maxOptions && p.length >= l.maxOptions) {
          i("Auswahlbegrenzung erreicht", `Du kannst maximal ${l.maxOptions} Optionen bei "${l.title}" auswählen.`, !0);
          return;
        }
        g[l.title] = [...p, u], b = !0;
      }
      b && (!l.multi || l.replaceArticle === !0 || l.multi && l.maxOptions && g[l.title].length === l.maxOptions) && He();
    }, ct = (l) => {
      const u = [];
      return (l.multi || l.optional) && u.push("Optional"), l.freeArticles && l.freeArticles > 0 && u.push(`${l.freeArticles} Optionen inbegriffen`), l.maxOptions && l.maxOptions > 0 && u.push(`Wähle bis zu ${l.maxOptions} Optionen`), u.join(", ");
    }, bt = () => {
      o("close-additionals");
    }, Ht = () => {
      D.value && D.value.image && o("click-image", D.value.image);
    }, ho = te(() => c.primaryColor), Ze = te(() => ia(c.primaryColor, 0.2)), me = te(() => Qs(c.primaryColor)), a = te(() => xe.value ? {
      backgroundColor: "#e2e8f0",
      color: "#a3a3a3",
      cursor: "not-allowed",
      opacity: "0.7",
      boxShadow: "none"
    } : {
      backgroundColor: c.primaryColor,
      color: me.value,
      cursor: "pointer",
      opacity: "1",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
    });
    return Vt(() => c.itemType, (l) => {
      l && typeof l == "string" && l.trim() !== "" ? console.log("itemType", l) : console.warn("Received empty or invalid itemType prop");
    }, { immediate: !0 }), (l, u) => (L(), K(ce, null, [
      I("div", ma, [
        I("div", ba, [
          I("div", va, [
            I("button", {
              onClick: bt,
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transition-colors duration-200"
            }, u[1] || (u[1] = [
              I("svg", {
                class: "w-6 h-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                I("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])),
            I("div", _a, [
              D.value.image && X.value ? (L(), K("div", ya, [
                I("img", {
                  src: D.value.image,
                  alt: D.value.nameDE,
                  class: "w-full object-cover rounded-xl shadow-lg border border-gray-200 cursor-pointer",
                  style: { height: "auto" },
                  onClick: Ht
                }, null, 8, wa)
              ])) : de("", !0),
              I("div", Ea, [
                I("h2", xa, oe(D.value.nameDE), 1),
                I("div", null, [
                  I("div", {
                    class: "description text-gray-600 mt-2",
                    innerHTML: D.value.descriptionDE
                  }, null, 8, Na),
                  Ee.value ? (L(), K("div", Oa, [
                    u[2] || (u[2] = I("span", { class: "font-semibold" }, "Enthält:", -1)),
                    Ls(" " + oe(Ee.value), 1)
                  ])) : de("", !0)
                ])
              ])
            ]),
            D.value.sizes && D.value.sizes.length > 1 ? (L(), K("div", Da, [
              u[3] || (u[3] = I("h3", { class: "item-additionals-textSize font-semibold text-gray-700 mb-3" }, "Größe wählen:", -1)),
              I("div", Va, [
                (L(!0), K(ce, null, on(D.value.sizes, (p) => (L(), K("button", {
                  key: p.vol,
                  onClick: (m) => ge(p.vol),
                  class: $t(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                    "hover:bg-gray-50": d.value !== p.vol
                  }]),
                  style: se(d.value === p.vol ? { backgroundColor: Ze.value, borderColor: c.primaryColor, color: me.value, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { color: e.primaryColor, borderColor: "#cbd5e1" })
                }, [
                  I("span", {
                    class: "item-additionals-textSize font-medium",
                    style: se(d.value === p.vol ? { color: me.value } : {})
                  }, oe(p.vol), 5),
                  I("span", {
                    class: "text-md font-semibold mt-1",
                    style: se(d.value === p.vol ? { color: me.value } : {})
                  }, oe(p.price.toFixed(2)) + "€", 5)
                ], 14, Sa))), 128))
              ])
            ])) : de("", !0)
          ])
        ]),
        I("div", Ca, [
          G.value.length > 0 && X.value ? (L(), K("div", Ta, [
            I("span", Aa, " Schritt " + oe(Q.value + 1) + " von " + oe(G.value.length), 1),
            I("div", Ia, [
              I("div", {
                class: "h-2.5 rounded-full transition-all duration-300 ease-in-out",
                style: se({ width: (Q.value + 1) / G.value.length * 100 + "%", backgroundColor: c.primaryColor })
              }, null, 4)
            ])
          ])) : de("", !0),
          I("div", ka, [
            F.value ? (L(), K(ce, { key: 0 }, [
              F.value.type === "replace" ? (L(), K("div", Pa, [
                I("h3", $a, oe(F.value.title), 1),
                I("div", Ma, [
                  (L(!0), K(ce, null, on(x(F.value), (p) => (L(), K("div", {
                    key: p.id,
                    onClick: (m) => po(F.value, p.id),
                    class: $t(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                      "hover:bg-gray-50": !Se(F.value, p.id)
                    }]),
                    style: se(Se(F.value, p.id) ? { backgroundColor: Ze.value, borderColor: c.primaryColor, color: me.value, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { color: e.primaryColor, borderColor: "#cbd5e1" })
                  }, [
                    p.imageUrl ? (L(), K("img", {
                      key: 0,
                      src: p.imageUrl,
                      alt: p.labelDE,
                      class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                    }, null, 8, ja)) : de("", !0),
                    I("div", Fa, [
                      I("span", {
                        class: "item-additionals-textSize font-medium",
                        style: se(Se(F.value, p.id) ? { color: me.value } : {})
                      }, oe(p.labelDE), 5),
                      p.cost > 0 ? (L(), K("span", {
                        key: 0,
                        class: "text-sm font-semibold",
                        style: se(Se(F.value, p.id) ? { color: me.value } : {})
                      }, " +" + oe(f(p.cost)), 5)) : de("", !0)
                    ]),
                    p.substances ? (L(), K("div", {
                      key: 1,
                      style: se(Se(F.value, p.id) ? { color: me.value } : {})
                    }, oe(mt(p.substances)), 5)) : de("", !0)
                  ], 14, Ra))), 128))
                ])
              ])) : F.value.type === "normal" ? (L(), K("div", za, [
                I("div", Ha, [
                  I("div", La, [
                    I("div", Ba, [
                      I("span", null, oe(F.value.title), 1),
                      ct(F.value) ? (L(), K("span", Ua, oe(ct(F.value)), 1)) : de("", !0)
                    ])
                  ]),
                  I("div", Wa, [
                    I("div", Ka, [
                      (L(!0), K(ce, null, on(x(F.value), (p) => (L(), K("div", {
                        key: p.id,
                        onClick: (m) => po(F.value, p.id),
                        class: $t(["option-item p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center text-center", {
                          "hover:bg-gray-50": !Se(F.value, p.id)
                        }]),
                        style: se(Se(F.value, p.id) ? { backgroundColor: Ze.value, borderColor: c.primaryColor, color: me.value, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { color: ho.value, borderColor: "#cbd5e1" })
                      }, [
                        p.imageUrl ? (L(), K("img", {
                          key: 0,
                          src: p.imageUrl,
                          alt: p.labelDE,
                          class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                        }, null, 8, Ga)) : de("", !0),
                        I("div", Ja, [
                          I("span", {
                            class: "item-additionals-textSize font-medium",
                            style: se(Se(F.value, p.id) ? { color: me.value } : {})
                          }, oe(p.labelDE), 5),
                          p.cost > 0 ? (L(), K("span", {
                            key: 0,
                            class: "text-sm font-semibold",
                            style: se(Se(F.value, p.id) ? { color: me.value } : {})
                          }, " +" + oe(f(p.cost)), 5)) : de("", !0),
                          p.cost < 0 ? (L(), K("span", {
                            key: 1,
                            class: "text-sm font-semibold",
                            style: se(Se(F.value, p.id) ? { color: me.value } : {})
                          }, oe(f(p.cost)), 5)) : de("", !0)
                        ]),
                        p.substances ? (L(), K("div", {
                          key: 1,
                          style: se(Se(F.value, p.id) ? { color: me.value } : {})
                        }, oe(mt(p.substances)), 5)) : de("", !0)
                      ], 14, qa))), 128))
                    ])
                  ])
                ])
              ])) : de("", !0)
            ], 64)) : (L(), K("p", Ya))
          ])
        ]),
        I("div", Qa, [
          I("div", Xa, [
            I("div", Za, [
              Me.value ? de("", !0) : (L(), K("button", {
                key: 0,
                onClick: bt,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: { backgroundColor: "#e2e8f0", color: "#475569" }
              }, " Abbrechen ")),
              Me.value ? (L(), K(ce, { key: 1 }, [
                I("button", {
                  onClick: ze,
                  class: "quantity-button decrement",
                  style: { "padding-bottom": "4px" }
                }, "- "),
                I("span", eu, oe(h.value), 1),
                I("button", {
                  onClick: fo,
                  class: "quantity-button increment",
                  style: se([{ "padding-bottom": "4px" }, { backgroundColor: c.primaryColor, color: me.value }])
                }, "+ ", 4)
              ], 64)) : de("", !0)
            ]),
            I("div", tu, [
              Ct.value ? de("", !0) : (L(), K("button", {
                key: 0,
                onClick: Le,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: { backgroundColor: "#e2e8f0", color: "#475569" }
              }, " Zurück ")),
              Me.value ? (L(), K("button", {
                key: 2,
                onClick: zt,
                class: "add-to-cart-button ml-10",
                style: se(a.value),
                disabled: xe.value
              }, " In den Korb (" + oe(f(R.value)) + ") ", 13, ou)) : (L(), K("button", {
                key: 1,
                onClick: He,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: se({ backgroundColor: c.primaryColor, color: me.value })
              }, " Weiter ", 4))
            ])
          ])
        ])
      ]),
      Pe(pa, null, {
        default: ds(() => [
          Pe(da, {
            "primary-color": e.primaryColor,
            title: r.value,
            message: s.value,
            modelValue: n.value,
            "onUpdate:modelValue": u[0] || (u[0] = (p) => n.value = p)
          }, null, 8, ["primary-color", "title", "message", "modelValue"])
        ]),
        _: 1
      })
    ], 64));
  }
}, ru = /* @__PURE__ */ sa(nu, [["styles", [ga]]]), su = /* @__PURE__ */ Yc(ru);
customElements.define("item-additionals", su);
